/*
 * Credential Lists
 */
const shopifyStoreUrl = "https://dietelement.in/";
window.totalProductsForDietQuiz = 0;
var uniqueIngredientsList = [],
  finalDietPlan = [],
  userName = "";
// Store all fetched products globally
window.allFetchedProducts = [];
let finalPlan = {
  Monday: {
    breakfast: {
      id: "meal002",
      name: "Ragi Dosa with Sambar",
      description:
        "Nutritious fermented millet crepe served with lentil vegetable stew",
      region: "South Indian",
      image_url: "https://example.com/images/ragi_dosa.jpg",
      preparation_time_minutes: 40,
      difficulty_level: "Medium",
      is_ayurvedic: true,
      nutritional_info: {
        calories: 350,
        protein_grams: 10,
        carbs_grams: 55,
        fat_grams: 9,
        fiber_grams: 6,
        sodium_mg: 300,
        glycemic_index: "Low",
        portion_size: "2 dosas (120g), 1 bowl sambar (150g)",
      },
      ingredients: [
        {
          name: "Ragi flour",
          quantity: "100g",
          substitutes: ["Jowar flour", "Bajra flour"],
        },
        {
          name: "Rice flour",
          quantity: "50g",
          substitutes: ["Brown rice flour"],
        },
        {
          name: "Toor dal",
          quantity: "50g",
          substitutes: ["Moong dal"],
        },
        {
          name: "Mixed vegetables",
          quantity: "100g",
          substitutes: ["Seasonal vegetables"],
        },
      ],
      input_compatibility: {
        age: ["teen", "adult", "senior"],
        gender: ["male", "female"],
        goal: ["weight_loss", "health_management", "general_health"],
        activity: ["light", "moderate", "active", "very_active"],
        diet_type: [
          "vegetarian",
          "jain",
          "sattvic",
          "gluten_free",
          "high_protein",
          "lactose_free",
        ],
        existing_disease: ["none", "diabetes", "obesity", "anemia"],
      },
      disease_modifications: {
        diabetes: {
          description: "Diabetes-friendly version",
          substitutions: [
            {
              original: "Rice flour",
              replacement: "More ragi flour",
              reason: "Lower glycemic index",
            },
          ],
          portion_changes: "Standard portion",
          additional_notes:
            "The high fiber content makes this suitable for diabetics",
        },
      },
      meal_timing: ["breakfast", "dinner"],
      compatibilityScore: 14,
    },
    lunch: {
      id: "meal012",
      name: "Besan Cheela with Mint Chutney",
      description:
        "A protein-rich, savory pancake made from chickpea flour and mild spices, served with refreshing mint chutney.",
      region: "North & West India",
      image_url: "https://example.com/images/besan_cheela.jpg",
      preparation_time_minutes: 15,
      difficulty_level: "Easy",
      is_ayurvedic: true,
      nutritional_info: {
        calories: 384,
        protein_grams: 21.4,
        carbs_grams: 59.5,
        fat_grams: 6.54,
        fiber_grams: 11.3,
        sodium_mg: 64.9,
        glycemic_index: "Low",
        portion_size: "2 medium cheelas (250g)",
      },
      ingredients: [
        {
          name: "Besan",
          quantity: "1 cup",
          substitutes: ["Moong Dal Flour", "Ragi Flour"],
        },
        {
          name: "Onion",
          quantity: "1/4 cup",
          substitutes: ["Spring Onion"],
        },
        {
          name: "Tomato",
          quantity: "1/4 cup",
          substitutes: ["Bell Pepper"],
        },
        {
          name: "Turmeric & Cumin Powder",
          quantity: "1/2 tsp",
          substitutes: [],
        },
      ],
      input_compatibility: {
        age: ["teen", "adult", "senior"],
        gender: ["male", "female"],
        goal: ["protein_intake", "quick_meal", "energy_boost"],
        activity: ["light", "moderate"],
        diet_type: [
          "vegetarian",
          "jain",
          "sattvic",
          "gluten_free",
          "lactose_free",
          "high_protein",
        ],
        existing_disease: ["diabetes", "hypertension", "low_energy"],
      },
      disease_modifications: {
        diabetes: {
          description: "Diabetic-friendly version",
          substitutions: ["Use moong dal flour instead of besan"],
          portion_changes: "No change",
          additional_notes: "Pair with yogurt for better digestion",
        },
        weight_management: {
          description: "Low-calorie version",
          substitutions: ["Use minimal oil"],
          portion_changes: "Reduce portion size",
          additional_notes: "Pair with vegetable salad",
        },
      },
      meal_timing: ["lunch", "dinner"],
      compatibilityScore: 8,
    },
    dinner: {
      id: "meal040",
      name: "Moong Dal & Vegetable Daliya",
      description:
        "A wholesome and protein-rich Indian dish made with broken wheat, lentils, and vegetables, perfect for a balanced meal.",
      region: "Indian",
      image_url: "https://example.com/images/moongdal_daliya.jpg",
      preparation_time_minutes: 25,
      difficulty_level: "Medium",
      is_ayurvedic: true,
      nutritional_info: {
        calories: 315,
        protein_grams: 14.5,
        carbs_grams: 60,
        fat_grams: 1.5,
        fiber_grams: 9,
        sodium_mg: 90,
        glycemic_index: "Medium",
        portion_size: "1 bowl (250g)",
      },
      ingredients: [
        {
          name: "Broken Wheat (Daliya)",
          quantity: "1/2 cup",
          substitutes: ["Quinoa", "Oats"],
        },
        {
          name: "Moong Dal",
          quantity: "1/4 cup",
          substitutes: ["Masoor Dal", "Toor Dal"],
        },
      ],
      input_compatibility: {
        age: ["child", "teen", "adult", "senior"],
        gender: ["male", "female"],
        goal: [
          "weight_loss",
          "weight_maintenance",
          "general_health",
          "health_management",
        ],
        activity: ["sedentary", "light", "moderate", "active"],
        diet_type: [
          "vegetarian",
          "jain",
          "sattvic",
          "gluten_free",
          "lactose_free",
          "high_protein",
        ],
        existing_disease: [
          "none",
          "diabetes",
          "hypertension",
          "digestive_disorders",
        ],
      },
      disease_modifications: {
        diabetes: {
          description: "Modified for diabetic patients",
          substitutions: [
            {
              original: "Cracked Wheat (Daliya)",
              replacement: "Quinoa",
              reason: "Lower glycemic index",
            },
          ],
          portion_changes: "Reduce portion size to 200g",
          additional_notes:
            "Add more fiber-rich vegetables to balance blood sugar",
        },
        hypertension: {
          description: "Modified for hypertension patients",
          substitutions: [],
          portion_changes: "Standard portion, avoid adding extra salt",
          additional_notes: "Use herbs and spices instead of salt for flavor",
        },
        digestive_disorders: {
          description: "Modified for individuals with digestive problems",
          substitutions: [
            {
              original: "Cracked Wheat (Daliya)",
              replacement: "Brown Rice",
              reason: "Easier to digest",
            },
          ],
          portion_changes: "Reduce portion to 200g",
          additional_notes:
            "Cook dal thoroughly and add mild spices for easy digestion",
        },
      },
      meal_timing: ["breakfast", "dinner"],
      compatibilityScore: 14,
    },
    morningSnack: {
      id: "meal025",
      name: "Vegetable Oats Upma with Flaxseeds",
      description:
        "A nutritious South Indian-style upma made with oats, vegetables, and flaxseeds for added fiber and omega-3s.",
      region: "Indian",
      image_url: "https://example.com/images/vegetable_oats_upma.jpg",
      preparation_time_minutes: 20,
      difficulty_level: "Easy",
      is_ayurvedic: true,
      nutritional_info: {
        calories: 235,
        protein_grams: 8.9,
        carbs_grams: 39,
        fat_grams: 7,
        fiber_grams: 8.8,
        sodium_mg: 23,
        glycemic_index: "Medium",
        portion_size: "1 bowl (250g)",
      },
      ingredients: [
        {
          name: "Oats",
          quantity: "1/2 cup",
          substitutes: ["Broken wheat", "Quinoa"],
        },
        {
          name: "Flax seed",
          quantity: "1 tbsp",
          substitutes: ["Chia seeds", "Sesame seeds"],
        },
        {
          name: "Mixed Vegetables",
          quantity: "1/2 cup",
          substitutes: ["Only leafy greens", "Bell peppers"],
        },
      ],
      input_compatibility: {
        age: ["child", "teen", "adult", "senior"],
        gender: ["male", "female"],
        goal: ["weight_loss", "general_health"],
        activity: ["light", "moderate"],
        diet_type: [
          "vegetarian",
          "vegan",
          "jain",
          "sattvic",
          "gluten_free",
          "lactose_free",
          "high_protein",
        ],
        existing_disease: ["diabetes", "heart_disease"],
      },
      disease_modifications: {
        diabetes: {
          description: "Lower glycemic load for diabetics",
          substitutions: [
            {
              original: "Oats",
              replacement: "Broken wheat",
              reason: "Lower glycemic index",
            },
          ],
          portion_changes: "Reduce oats to 1/3 cup",
          additional_notes: "Add extra flaxseeds for fiber",
        },
      },
      meal_timing: ["breakfast", "snack"],
      compatibilityScore: 14,
    },
    eveningSnack: {
      id: "meal003",
      name: "Oats Idli with Mint Chutney",
      description:
        "Healthy steamed savory cake made with oats, served with mint chutney",
      region: "South Indian Fusion",
      image_url: "https://example.com/images/oats_idli.jpg",
      preparation_time_minutes: 30,
      difficulty_level: "Easy",
      is_ayurvedic: false,
      nutritional_info: {
        calories: 250,
        protein_grams: 10,
        carbs_grams: 40,
        fat_grams: 4,
        fiber_grams: 5,
        sodium_mg: 150,
        glycemic_index: "Low",
        portion_size: "4 idlis (120g), 2 tbsp chutney (30g)",
      },
      ingredients: [
        {
          name: "Oats",
          quantity: "100g",
          substitutes: ["Quinoa", "Ragi"],
        },
        {
          name: "Yogurt",
          quantity: "50g",
          substitutes: ["Plant-based yogurt"],
        },
        {
          name: "Vegetables",
          quantity: "50g",
          substitutes: [],
        },
        {
          name: "Fresh mint",
          quantity: "30g",
          substitutes: ["Coriander leaves"],
        },
      ],
      input_compatibility: {
        age: ["teen", "adult", "senior"],
        gender: ["male", "female"],
        goal: [
          "weight_loss",
          "weight_maintenance",
          "general_health",
          "health_management",
        ],
        activity: ["sedentary", "light", "moderate", "active"],
        diet_type: [
          "vegetarian",
          "jain",
          "sattvic",
          "high_protein",
          "lactose_free",
        ],
        existing_disease: [
          "none",
          "diabetes",
          "obesity",
          "heart_disease",
          "hypertension",
          "digestive_disorders",
        ],
      },
      disease_modifications: {
        diabetes: {
          description: "Already diabetic-friendly",
          substitutions: [],
          portion_changes: "Standard portion",
          additional_notes: "Low glycemic index meal",
        },
        heart_disease: {
          description: "Heart-healthy version",
          substitutions: [
            {
              original: "Yogurt",
              replacement: "Low-fat yogurt",
              reason: "Lower saturated fat",
            },
          ],
          portion_changes: "Standard portion",
          additional_notes:
            "Rich in soluble fiber which helps reduce cholesterol",
        },
      },
      meal_timing: ["breakfast", "snack"],
      compatibilityScore: 14,
    },
    totalMacros: {
      calories: "1534",
      protein: "65",
      carbs: "254",
      fats: "28",
    },
  },
  Tuesday: {
    breakfast: {
      id: "meal040",
      name: "Moong Dal & Vegetable Daliya",
      description:
        "A wholesome and protein-rich Indian dish made with broken wheat, lentils, and vegetables, perfect for a balanced meal.",
      region: "Indian",
      image_url: "https://example.com/images/moongdal_daliya.jpg",
      preparation_time_minutes: 25,
      difficulty_level: "Medium",
      is_ayurvedic: true,
      nutritional_info: {
        calories: 315,
        protein_grams: 14.5,
        carbs_grams: 60,
        fat_grams: 1.5,
        fiber_grams: 9,
        sodium_mg: 90,
        glycemic_index: "Medium",
        portion_size: "1 bowl (250g)",
      },
      ingredients: [
        {
          name: "Broken Wheat (Daliya)",
          quantity: "1/2 cup",
          substitutes: ["Quinoa", "Oats"],
        },
        {
          name: "Moong Dal",
          quantity: "1/4 cup",
          substitutes: ["Masoor Dal", "Toor Dal"],
        },
      ],
      input_compatibility: {
        age: ["child", "teen", "adult", "senior"],
        gender: ["male", "female"],
        goal: [
          "weight_loss",
          "weight_maintenance",
          "general_health",
          "health_management",
        ],
        activity: ["sedentary", "light", "moderate", "active"],
        diet_type: [
          "vegetarian",
          "jain",
          "sattvic",
          "gluten_free",
          "lactose_free",
          "high_protein",
        ],
        existing_disease: [
          "none",
          "diabetes",
          "hypertension",
          "digestive_disorders",
        ],
      },
      disease_modifications: {
        diabetes: {
          description: "Modified for diabetic patients",
          substitutions: [
            {
              original: "Cracked Wheat (Daliya)",
              replacement: "Quinoa",
              reason: "Lower glycemic index",
            },
          ],
          portion_changes: "Reduce portion size to 200g",
          additional_notes:
            "Add more fiber-rich vegetables to balance blood sugar",
        },
        hypertension: {
          description: "Modified for hypertension patients",
          substitutions: [],
          portion_changes: "Standard portion, avoid adding extra salt",
          additional_notes: "Use herbs and spices instead of salt for flavor",
        },
        digestive_disorders: {
          description: "Modified for individuals with digestive problems",
          substitutions: [
            {
              original: "Cracked Wheat (Daliya)",
              replacement: "Brown Rice",
              reason: "Easier to digest",
            },
          ],
          portion_changes: "Reduce portion to 200g",
          additional_notes:
            "Cook dal thoroughly and add mild spices for easy digestion",
        },
      },
      meal_timing: ["breakfast", "dinner"],
      compatibilityScore: 14,
    },
    lunch: {
      id: "meal001",
      name: "Vegetable Dal Khichdi with Raita",
      description:
        "Nutritious one-pot meal with rice, lentils and mixed vegetables, served with yogurt side dish",
      region: "North Indian",
      image_url: "https://example.com/images/khichdi.jpg",
      preparation_time_minutes: 30,
      difficulty_level: "Easy",
      is_ayurvedic: true,
      nutritional_info: {
        calories: 308,
        protein_grams: 11.8,
        carbs_grams: 47.8,
        fat_grams: 5,
        fiber_grams: 8,
        sodium_mg: 1200,
        glycemic_index: "Medium",
        portion_size: "1 bowl (250g) khichdi, 1 small bowl (100g) raita",
      },
      ingredients: [
        {
          name: "Rice",
          quantity: "100g",
          substitutes: ["Brown rice", "Quinoa"],
        },
        {
          name: "Yellow Moong Dal",
          quantity: "50g",
          substitutes: ["Red lentils", "Toor dal"],
        },
        {
          name: "Mixed Vegetables",
          quantity: "100g",
          substitutes: ["Seasonal vegetables"],
        },
        {
          name: "Yogurt",
          quantity: "100g",
          substitutes: ["Plant-based yogurt"],
        },
        {
          name: "Ghee",
          quantity: "1 tsp",
          substitutes: ["Olive oil"],
        },
      ],
      input_compatibility: {
        age: ["child", "teen", "adult", "senior"],
        gender: ["male", "female"],
        goal: [
          "weight_maintenance",
          "weight_loss",
          "general_health",
          "health_management",
        ],
        activity: ["sedentary", "light", "moderate", "active"],
        diet_type: [
          "vegetarian",
          "jain",
          "sattvic",
          "gluten_free",
          "high_protein",
          "lactose_free",
        ],
        existing_disease: [
          "none",
          "diabetes",
          "hypertension",
          "digestive_disorders",
        ],
      },
      disease_modifications: {
        diabetes: {
          description: "Modified for diabetic patients",
          substitutions: [
            {
              original: "Rice",
              replacement: "Brown rice",
              reason: "Lower glycemic index",
            },
          ],
          portion_changes: "Reduce to 200g total serving",
          additional_notes: "Pair with more fiber-rich vegetables",
        },
        hypertension: {
          description: "Modified for hypertension patients",
          substitutions: [],
          portion_changes: "Standard portion, no added salt",
          additional_notes: "Use herbs and spices instead of salt for flavor",
        },
      },
      meal_timing: ["lunch", "dinner"],
      compatibilityScore: 14,
    },
    dinner: {
      id: "meal028",
      name: "Rajma Chawal with Vegetable Raita",
      description:
        "A comforting North Indian dish of kidney beans and rice served with a refreshing vegetable raita.",
      region: "Indian",
      image_url: "https://example.com/images/rajma_chawal.jpg",
      preparation_time_minutes: 30,
      difficulty_level: "Medium",
      is_ayurvedic: true,
      nutritional_info: {
        calories: 265,
        protein_grams: 11.8,
        carbs_grams: 50.3,
        fat_grams: 2.2,
        fiber_grams: 7.2,
        sodium_mg: 55,
        glycemic_index: "Medium",
        portion_size: "1 plate (300g)",
      },
      ingredients: [
        {
          name: "Rajma",
          quantity: "1/2 cup",
          substitutes: ["Black beans", "Chickpeas"],
        },
        {
          name: "Rice",
          quantity: "1/2 cup",
          substitutes: ["Brown rice", "Quinoa"],
        },
        {
          name: "Vegetable Raita",
          quantity: "1/2 cup",
          substitutes: ["Plain yogurt", "Coconut yogurt"],
        },
      ],
      input_compatibility: {
        age: ["child", "teen", "adult", "senior"],
        gender: ["male", "female"],
        goal: ["weight_maintenance", "general_health"],
        activity: ["light", "moderate"],
        diet_type: ["vegetarian", "gluten_free", "high_protein"],
        existing_disease: ["diabetes", "heart_disease"],
      },
      disease_modifications: {
        diabetes: {
          description: "Diabetes-friendly version",
          substitutions: [
            {
              original: "Rice",
              replacement: "Brown rice",
              reason: "Lower glycemic index",
            },
          ],
          portion_changes: "Reduce rice to 1/3 cup",
          additional_notes: "Increase fiber by adding extra vegetables",
        },
      },
      meal_timing: ["lunch", "dinner"],
      compatibilityScore: 8,
    },
    morningSnack: {
      id: "meal023",
      name: "Muesli Bowl with Mixed Nuts",
      description:
        "A fiber-rich breakfast bowl with muesli, mixed nuts, and milk or yogurt for sustained energy and nutrition.",
      region: "Western",
      image_url: "https://example.com/images/muesli_mixed_nuts.jpg",
      preparation_time_minutes: 5,
      difficulty_level: "Easy",
      is_ayurvedic: false,
      nutritional_info: {
        calories: 410,
        protein_grams: 15,
        carbs_grams: 60,
        fat_grams: 12,
        fiber_grams: 7,
        sodium_mg: 100,
        glycemic_index: "Medium",
        portion_size: "1 bowl (250g)",
      },
      ingredients: [
        {
          name: "Muesli",
          quantity: "1 cup",
          substitutes: ["Oats", "Granola"],
        },
        {
          name: "Mixed Nuts (Almonds, Walnuts, Cashews)",
          quantity: "2 tbsp",
          substitutes: ["Pumpkin seeds", "Sunflower seeds"],
        },
        {
          name: "Milk or Yogurt",
          quantity: "200ml",
          substitutes: ["Almond milk", "Coconut yogurt"],
        },
        {
          name: "Honey",
          quantity: "1 tsp",
          substitutes: ["Maple syrup", "Stevia (for diabetics)"],
        },
      ],
      input_compatibility: {
        age: ["child", "teen", "adult", "senior"],
        gender: ["male", "female"],
        goal: ["muscle_gain", "energy_boost", "general_health"],
        activity: ["moderate", "active"],
        diet_type: ["vegetarian", "eggetarian", "gluten_free", "high_protein"],
        existing_disease: ["none", "diabetes", "heart_disease"],
      },
      disease_modifications: {
        diabetes: {
          description: "Modified for diabetic patients",
          substitutions: [
            {
              original: "Honey",
              replacement: "Stevia",
              reason: "Lowers sugar intake",
            },
          ],
          portion_changes: "Reduce muesli to 3/4 cup",
          additional_notes: "Add more nuts for healthy fats",
        },
      },
      meal_timing: ["breakfast", "snack"],
      compatibilityScore: 4,
    },
    eveningSnack: {
      id: "meal004",
      name: "Sprouted Moong Salad with Lemon Dressing",
      description:
        "A refreshing and protein-rich sprouted moong dal salad with fresh veggies and a zesty lemon dressing.",
      region: "Indian",
      image_url: "https://example.com/images/sprouted_moong_salad.jpg",
      preparation_time_minutes: 15,
      difficulty_level: "Easy",
      is_ayurvedic: true,
      nutritional_info: {
        calories: 120,
        protein_grams: 9.2,
        carbs_grams: 21,
        fat_grams: 0.5,
        fiber_grams: 5,
        sodium_mg: 20,
        glycemic_index: "Low",
        portion_size: "1 medium bowl (200g)",
      },
      ingredients: [
        {
          name: "Sprouted Moong Dal",
          quantity: "100g",
          substitutes: ["Chickpeas", "Lentils"],
        },
        {
          name: "Cucumber",
          quantity: "50g",
          substitutes: ["Zucchini"],
        },
        {
          name: "Tomato",
          quantity: "50g",
          substitutes: ["Cherry tomatoes"],
        },
        {
          name: "Lemon Juice",
          quantity: "1 tbsp",
          substitutes: ["Apple cider vinegar"],
        },
      ],
      input_compatibility: {
        age: ["child", "teen", "adult", "senior"],
        gender: ["male", "female"],
        goal: ["weight_loss", "general_health"],
        activity: ["sedentary", "light", "moderate"],
        diet_type: [
          "vegetarian",
          "jain",
          "sattvic",
          "gluten_free",
          "high_protein",
          "lactose_free",
          "vegan",
          "keto",
        ],
        existing_disease: [
          "none",
          "diabetes",
          "hypertension",
          "digestive_disorders",
        ],
      },
      disease_modifications: {
        diabetes: {
          description: "Diabetic-friendly meal",
          substitutions: [],
          portion_changes: "No change",
          additional_notes: "Avoid adding sweet dressings",
        },
        hypertension: {
          description: "Low-sodium version",
          substitutions: [],
          portion_changes: "Use minimal salt",
          additional_notes: "Increase cucumber for hydration",
        },
      },
      meal_timing: ["breakfast", "snack"],
      compatibilityScore: 14,
    },
    totalMacros: {
      calories: "1418",
      protein: "62",
      carbs: "239",
      fats: "21",
    },
  },
  Wednesday: {
    breakfast: {
      id: "meal003",
      name: "Oats Idli with Mint Chutney",
      description:
        "Healthy steamed savory cake made with oats, served with mint chutney",
      region: "South Indian Fusion",
      image_url: "https://example.com/images/oats_idli.jpg",
      preparation_time_minutes: 30,
      difficulty_level: "Easy",
      is_ayurvedic: false,
      nutritional_info: {
        calories: 250,
        protein_grams: 10,
        carbs_grams: 40,
        fat_grams: 4,
        fiber_grams: 5,
        sodium_mg: 150,
        glycemic_index: "Low",
        portion_size: "4 idlis (120g), 2 tbsp chutney (30g)",
      },
      ingredients: [
        {
          name: "Oats",
          quantity: "100g",
          substitutes: ["Quinoa", "Ragi"],
        },
        {
          name: "Yogurt",
          quantity: "50g",
          substitutes: ["Plant-based yogurt"],
        },
        {
          name: "Vegetables",
          quantity: "50g",
          substitutes: [],
        },
        {
          name: "Fresh mint",
          quantity: "30g",
          substitutes: ["Coriander leaves"],
        },
      ],
      input_compatibility: {
        age: ["teen", "adult", "senior"],
        gender: ["male", "female"],
        goal: [
          "weight_loss",
          "weight_maintenance",
          "general_health",
          "health_management",
        ],
        activity: ["sedentary", "light", "moderate", "active"],
        diet_type: [
          "vegetarian",
          "jain",
          "sattvic",
          "high_protein",
          "lactose_free",
        ],
        existing_disease: [
          "none",
          "diabetes",
          "obesity",
          "heart_disease",
          "hypertension",
          "digestive_disorders",
        ],
      },
      disease_modifications: {
        diabetes: {
          description: "Already diabetic-friendly",
          substitutions: [],
          portion_changes: "Standard portion",
          additional_notes: "Low glycemic index meal",
        },
        heart_disease: {
          description: "Heart-healthy version",
          substitutions: [
            {
              original: "Yogurt",
              replacement: "Low-fat yogurt",
              reason: "Lower saturated fat",
            },
          ],
          portion_changes: "Standard portion",
          additional_notes:
            "Rich in soluble fiber which helps reduce cholesterol",
        },
      },
      meal_timing: ["breakfast", "snack"],
      compatibilityScore: 14,
    },
    lunch: {
      id: "meal030",
      name: "Bajra Roti with Palak Dal",
      description:
        "A high-fiber meal featuring gluten-free bajra roti served with protein-rich spinach lentil dal.",
      region: "Indian",
      image_url: "https://example.com/images/bajra_roti_palak_dal.jpg",
      preparation_time_minutes: 35,
      difficulty_level: "Medium",
      is_ayurvedic: true,
      nutritional_info: {
        calories: 350,
        protein_grams: 18,
        carbs_grams: 60,
        fat_grams: 3,
        fiber_grams: 15,
        sodium_mg: 15,
        glycemic_index: "Low",
        portion_size: "2 rotis + 1 bowl dal (250g)",
      },
      ingredients: [
        {
          name: "Bajra Flour",
          quantity: "1/2 cup",
          substitutes: ["Jowar flour", "Ragi flour"],
        },
        {
          name: "Spinach",
          quantity: "1 cup",
          substitutes: ["Kale", "Fenugreek leaves"],
        },
        {
          name: "Lentils",
          quantity: "1/2 cup",
          substitutes: ["Toor dal", "Masoor dal"],
        },
        {
          name: "Garlic",
          quantity: "2 cloves",
          substitutes: ["Ginger", "Asafoetida"],
        },
      ],
      input_compatibility: {
        age: ["teen", "adult", "senior"],
        gender: ["male", "female"],
        goal: ["muscle_gain", "weight_loss", "general_health"],
        activity: ["moderate", "high"],
        diet_type: [
          "vegetarian",
          "jain",
          "sattvic",
          "gluten_free",
          "lactose_free",
          "high_protein",
        ],
        existing_disease: ["diabetes", "heart_disease", "none"],
      },
      disease_modifications: {
        heart_disease: {
          description: "Modified for heart patients",
          substitutions: [
            {
              original: "Salt",
              replacement: "Black salt",
              reason: "Lower sodium content",
            },
          ],
          portion_changes: "Reduce dal portion by 1/4",
          additional_notes: "Increase spinach for antioxidants",
        },
      },
      meal_timing: ["lunch", "dinner"],
      compatibilityScore: 10,
    },
    dinner: {
      id: "meal002",
      name: "Ragi Dosa with Sambar",
      description:
        "Nutritious fermented millet crepe served with lentil vegetable stew",
      region: "South Indian",
      image_url: "https://example.com/images/ragi_dosa.jpg",
      preparation_time_minutes: 40,
      difficulty_level: "Medium",
      is_ayurvedic: true,
      nutritional_info: {
        calories: 350,
        protein_grams: 10,
        carbs_grams: 55,
        fat_grams: 9,
        fiber_grams: 6,
        sodium_mg: 300,
        glycemic_index: "Low",
        portion_size: "2 dosas (120g), 1 bowl sambar (150g)",
      },
      ingredients: [
        {
          name: "Ragi flour",
          quantity: "100g",
          substitutes: ["Jowar flour", "Bajra flour"],
        },
        {
          name: "Rice flour",
          quantity: "50g",
          substitutes: ["Brown rice flour"],
        },
        {
          name: "Toor dal",
          quantity: "50g",
          substitutes: ["Moong dal"],
        },
        {
          name: "Mixed vegetables",
          quantity: "100g",
          substitutes: ["Seasonal vegetables"],
        },
      ],
      input_compatibility: {
        age: ["teen", "adult", "senior"],
        gender: ["male", "female"],
        goal: ["weight_loss", "health_management", "general_health"],
        activity: ["light", "moderate", "active", "very_active"],
        diet_type: [
          "vegetarian",
          "jain",
          "sattvic",
          "gluten_free",
          "high_protein",
          "lactose_free",
        ],
        existing_disease: ["none", "diabetes", "obesity", "anemia"],
      },
      disease_modifications: {
        diabetes: {
          description: "Diabetes-friendly version",
          substitutions: [
            {
              original: "Rice flour",
              replacement: "More ragi flour",
              reason: "Lower glycemic index",
            },
          ],
          portion_changes: "Standard portion",
          additional_notes:
            "The high fiber content makes this suitable for diabetics",
        },
      },
      meal_timing: ["breakfast", "dinner"],
      compatibilityScore: 14,
    },
    morningSnack: {
      id: "meal021",
      name: "Greek Yogurt with Nuts & Honey",
      description:
        "A protein-rich snack featuring creamy Greek yogurt, a mix of nuts, and natural honey for sweetness.",
      region: "Mediterranean",
      image_url: "https://example.com/images/greek_yogurt_nuts.jpg",
      preparation_time_minutes: 5,
      difficulty_level: "Easy",
      is_ayurvedic: true,
      nutritional_info: {
        calories: 347,
        protein_grams: 21,
        carbs_grams: 16.7,
        fat_grams: 23.5,
        fiber_grams: 3,
        sodium_mg: 100,
        glycemic_index: "Low",
        portion_size: "1 bowl (200g)",
      },
      ingredients: [
        {
          name: "Greek Yogurt",
          quantity: "150g",
          substitutes: ["Hung curd", "Coconut yogurt"],
        },
        {
          name: "Mixed Nuts (Almonds, Walnuts, Cashews)",
          quantity: "2 tbsp",
          substitutes: ["Sunflower seeds", "Pumpkin seeds"],
        },
        {
          name: "Honey",
          quantity: "1 tsp",
          substitutes: ["Maple syrup", "Jaggery syrup"],
        },
      ],
      input_compatibility: {
        age: ["teen", "adult", "senior"],
        gender: ["male", "female"],
        goal: ["muscle_gain", "general_health", "weight_maintenance"],
        activity: ["light", "moderate"],
        diet_type: ["vegetarian", "high_protein"],
        existing_disease: ["none", "diabetes"],
      },
      disease_modifications: {
        diabetes: {
          description: "Modified for diabetic patients",
          substitutions: [
            {
              original: "Honey",
              replacement: "Stevia",
              reason: "Reduces sugar content",
            },
          ],
          portion_changes: "Reduce to 100g yogurt",
          additional_notes: "Use unsweetened yogurt",
        },
      },
      meal_timing: ["snack", "breakfast"],
      compatibilityScore: 8,
    },
    eveningSnack: {
      id: "meal018",
      name: "Oats & Chia Pudding with Almonds",
      description:
        "A nutritious, fiber-rich pudding made with overnight-soaked oats, chia seeds, milk, and topped with almonds.",
      region: "Global",
      image_url: "https://example.com/images/oats_chia_pudding.jpg",
      preparation_time_minutes: 10,
      difficulty_level: "Easy",
      is_ayurvedic: true,
      nutritional_info: {
        calories: 309,
        protein_grams: 11.1,
        carbs_grams: 42.8,
        fat_grams: 10.8,
        fiber_grams: 6.9,
        sodium_mg: 55,
        glycemic_index: "Low",
        portion_size: "1 bowl (200g)",
      },
      ingredients: [
        {
          name: "Rolled Oats",
          quantity: "40g",
          substitutes: ["Steel-cut oats", "Quinoa flakes"],
        },
        {
          name: "Chia Seeds",
          quantity: "1 tbsp",
          substitutes: ["Flaxseeds", "Basil seeds"],
        },
        {
          name: "Milk",
          quantity: "150ml",
          substitutes: ["Almond milk", "Coconut milk"],
        },
        {
          name: "Almonds",
          quantity: "6-8 pieces",
          substitutes: ["Walnuts", "Cashews"],
        },
        {
          name: "Honey",
          quantity: "1 tsp",
          substitutes: ["Maple syrup", "Jaggery"],
        },
      ],
      input_compatibility: {
        age: ["child", "teen", "adult", "senior"],
        gender: ["male", "female"],
        goal: ["weight_loss", "muscle_gain", "general_health", "energy_boost"],
        activity: ["light", "moderate", "active"],
        diet_type: [
          "vegetarian",
          "vegan",
          "jain",
          "sattvic",
          "gluten_free",
          "lactose_free",
          "high_protein",
        ],
        existing_disease: ["none", "diabetes", "heart_disease"],
      },
      disease_modifications: {
        diabetes: {
          description: "Modified for diabetic patients",
          substitutions: [
            {
              original: "Honey",
              replacement: "Stevia",
              reason: "Reduces sugar content",
            },
          ],
          portion_changes: "Reduce to 30g oats",
          additional_notes: "Add more nuts for healthy fats",
        },
        heart_disease: {
          description: "Modified for heart patients",
          substitutions: [
            {
              original: "Milk",
              replacement: "Almond milk",
              reason: "Reduces saturated fat intake",
            },
          ],
          portion_changes: "Keep standard portion",
          additional_notes: "Use unsalted nuts for better heart health",
        },
      },
      meal_timing: ["breakfast", "snack"],
      compatibilityScore: 14,
    },
    totalMacros: {
      calories: "1606",
      protein: "70",
      carbs: "215",
      fats: "50",
    },
  },
  Thursday: {
    breakfast: {
      id: "meal022",
      name: "Poha with Flaxseeds & Peanuts",
      description:
        "A light and nutritious flattened rice dish enriched with flaxseeds and crunchy peanuts for a protein and fiber boost.",
      region: "Indian",
      image_url: "https://example.com/images/poha_flaxseeds_peanuts.jpg",
      preparation_time_minutes: 15,
      difficulty_level: "Easy",
      is_ayurvedic: true,
      nutritional_info: {
        calories: 292,
        protein_grams: 8.5,
        carbs_grams: 45.7,
        fat_grams: 10.3,
        fiber_grams: 4.6,
        sodium_mg: 64,
        glycemic_index: "Medium",
        portion_size: "1 bowl (250g)",
      },
      ingredients: [
        {
          name: "Flattened Rice (Poha)",
          quantity: "1 cup",
          substitutes: ["Brown rice flakes", "Quinoa flakes"],
        },
        {
          name: "Flax seed",
          quantity: "1 tbsp",
          substitutes: ["Chia seeds", "Sunflower seeds"],
        },
        {
          name: "Peanuts",
          quantity: "2 tbsp",
          substitutes: ["Almonds", "Cashews"],
        },
        {
          name: "Turmeric",
          quantity: "1/4 tsp",
          substitutes: ["Saffron", "Paprika"],
        },
      ],
      input_compatibility: {
        age: ["teen", "adult", "senior"],
        gender: ["male", "female"],
        goal: ["weight_maintenance", "general_health", "energy_boost"],
        activity: ["light", "moderate"],
        diet_type: [
          "vegetarian",
          "jain",
          "sattvic",
          "gluten_free",
          "lactose_free",
          "high_protein",
        ],
        existing_disease: ["none", "diabetes", "heart_disease"],
      },
      disease_modifications: {
        diabetes: {
          description: "Modified for diabetic patients",
          substitutions: [
            {
              original: "Flattened Rice (Poha)",
              replacement: "Brown rice flakes",
              reason: "Lower glycemic index",
            },
          ],
          portion_changes: "Reduce to 3/4 cup poha",
          additional_notes: "Add extra flaxseeds for fiber",
        },
      },
      meal_timing: ["breakfast", "snack"],
      compatibilityScore: 8,
    },
    lunch: {
      id: "meal028",
      name: "Rajma Chawal with Vegetable Raita",
      description:
        "A comforting North Indian dish of kidney beans and rice served with a refreshing vegetable raita.",
      region: "Indian",
      image_url: "https://example.com/images/rajma_chawal.jpg",
      preparation_time_minutes: 30,
      difficulty_level: "Medium",
      is_ayurvedic: true,
      nutritional_info: {
        calories: 265,
        protein_grams: 11.8,
        carbs_grams: 50.3,
        fat_grams: 2.2,
        fiber_grams: 7.2,
        sodium_mg: 55,
        glycemic_index: "Medium",
        portion_size: "1 plate (300g)",
      },
      ingredients: [
        {
          name: "Rajma",
          quantity: "1/2 cup",
          substitutes: ["Black beans", "Chickpeas"],
        },
        {
          name: "Rice",
          quantity: "1/2 cup",
          substitutes: ["Brown rice", "Quinoa"],
        },
        {
          name: "Vegetable Raita",
          quantity: "1/2 cup",
          substitutes: ["Plain yogurt", "Coconut yogurt"],
        },
      ],
      input_compatibility: {
        age: ["child", "teen", "adult", "senior"],
        gender: ["male", "female"],
        goal: ["weight_maintenance", "general_health"],
        activity: ["light", "moderate"],
        diet_type: ["vegetarian", "gluten_free", "high_protein"],
        existing_disease: ["diabetes", "heart_disease"],
      },
      disease_modifications: {
        diabetes: {
          description: "Diabetes-friendly version",
          substitutions: [
            {
              original: "Rice",
              replacement: "Brown rice",
              reason: "Lower glycemic index",
            },
          ],
          portion_changes: "Reduce rice to 1/3 cup",
          additional_notes: "Increase fiber by adding extra vegetables",
        },
      },
      meal_timing: ["lunch", "dinner"],
      compatibilityScore: 8,
    },
    dinner: {
      id: "meal030",
      name: "Bajra Roti with Palak Dal",
      description:
        "A high-fiber meal featuring gluten-free bajra roti served with protein-rich spinach lentil dal.",
      region: "Indian",
      image_url: "https://example.com/images/bajra_roti_palak_dal.jpg",
      preparation_time_minutes: 35,
      difficulty_level: "Medium",
      is_ayurvedic: true,
      nutritional_info: {
        calories: 350,
        protein_grams: 18,
        carbs_grams: 60,
        fat_grams: 3,
        fiber_grams: 15,
        sodium_mg: 15,
        glycemic_index: "Low",
        portion_size: "2 rotis + 1 bowl dal (250g)",
      },
      ingredients: [
        {
          name: "Bajra Flour",
          quantity: "1/2 cup",
          substitutes: ["Jowar flour", "Ragi flour"],
        },
        {
          name: "Spinach",
          quantity: "1 cup",
          substitutes: ["Kale", "Fenugreek leaves"],
        },
        {
          name: "Lentils",
          quantity: "1/2 cup",
          substitutes: ["Toor dal", "Masoor dal"],
        },
        {
          name: "Garlic",
          quantity: "2 cloves",
          substitutes: ["Ginger", "Asafoetida"],
        },
      ],
      input_compatibility: {
        age: ["teen", "adult", "senior"],
        gender: ["male", "female"],
        goal: ["muscle_gain", "weight_loss", "general_health"],
        activity: ["moderate", "high"],
        diet_type: [
          "vegetarian",
          "jain",
          "sattvic",
          "gluten_free",
          "lactose_free",
          "high_protein",
        ],
        existing_disease: ["diabetes", "heart_disease", "none"],
      },
      disease_modifications: {
        heart_disease: {
          description: "Modified for heart patients",
          substitutions: [
            {
              original: "Salt",
              replacement: "Black salt",
              reason: "Lower sodium content",
            },
          ],
          portion_changes: "Reduce dal portion by 1/4",
          additional_notes: "Increase spinach for antioxidants",
        },
      },
      meal_timing: ["lunch", "dinner"],
      compatibilityScore: 10,
    },
    morningSnack: {
      id: "meal022",
      name: "Poha with Flaxseeds & Peanuts",
      description:
        "A light and nutritious flattened rice dish enriched with flaxseeds and crunchy peanuts for a protein and fiber boost.",
      region: "Indian",
      image_url: "https://example.com/images/poha_flaxseeds_peanuts.jpg",
      preparation_time_minutes: 15,
      difficulty_level: "Easy",
      is_ayurvedic: true,
      nutritional_info: {
        calories: 292,
        protein_grams: 8.5,
        carbs_grams: 45.7,
        fat_grams: 10.3,
        fiber_grams: 4.6,
        sodium_mg: 64,
        glycemic_index: "Medium",
        portion_size: "1 bowl (250g)",
      },
      ingredients: [
        {
          name: "Flattened Rice (Poha)",
          quantity: "1 cup",
          substitutes: ["Brown rice flakes", "Quinoa flakes"],
        },
        {
          name: "Flax seed",
          quantity: "1 tbsp",
          substitutes: ["Chia seeds", "Sunflower seeds"],
        },
        {
          name: "Peanuts",
          quantity: "2 tbsp",
          substitutes: ["Almonds", "Cashews"],
        },
        {
          name: "Turmeric",
          quantity: "1/4 tsp",
          substitutes: ["Saffron", "Paprika"],
        },
      ],
      input_compatibility: {
        age: ["teen", "adult", "senior"],
        gender: ["male", "female"],
        goal: ["weight_maintenance", "general_health", "energy_boost"],
        activity: ["light", "moderate"],
        diet_type: [
          "vegetarian",
          "jain",
          "sattvic",
          "gluten_free",
          "lactose_free",
          "high_protein",
        ],
        existing_disease: ["none", "diabetes", "heart_disease"],
      },
      disease_modifications: {
        diabetes: {
          description: "Modified for diabetic patients",
          substitutions: [
            {
              original: "Flattened Rice (Poha)",
              replacement: "Brown rice flakes",
              reason: "Lower glycemic index",
            },
          ],
          portion_changes: "Reduce to 3/4 cup poha",
          additional_notes: "Add extra flaxseeds for fiber",
        },
      },
      meal_timing: ["breakfast", "snack"],
      compatibilityScore: 8,
    },
    eveningSnack: {
      id: "meal024",
      name: "Almond & Dates Energy Bars",
      description:
        "A naturally sweetened, no-bake energy bar packed with almonds, dates, and seeds for a quick, healthy snack.",
      region: "Global",
      image_url: "https://example.com/images/almond_dates_bar.jpg",
      preparation_time_minutes: 10,
      difficulty_level: "Easy",
      is_ayurvedic: true,
      nutritional_info: {
        calories: 752,
        protein_grams: 14.3,
        carbs_grams: 74.5,
        fat_grams: 48.7,
        fiber_grams: 11.5,
        sodium_mg: 1,
        glycemic_index: "Medium",
        portion_size: "1 bar (50g)",
      },
      ingredients: [
        {
          name: "Almonds",
          quantity: "1/2 cup",
          substitutes: ["Cashews", "Walnuts"],
        },
        {
          name: "Dates",
          quantity: "1/2 cup",
          substitutes: ["Figs", "Raisins"],
        },
        {
          name: "Flax seed",
          quantity: "1 tbsp",
          substitutes: ["Chia seeds", "Pumpkin seeds"],
        },
        {
          name: "Coconut Oil",
          quantity: "1 tbsp",
          substitutes: ["Ghee", "Peanut butter"],
        },
      ],
      input_compatibility: {
        age: ["child", "teen", "adult", "senior"],
        gender: ["male", "female"],
        goal: ["energy_boost", "weight_maintenance", "general_health"],
        activity: ["light", "moderate"],
        diet_type: [
          "vegetarian",
          "vegan",
          "jain",
          "sattvic",
          "gluten_free",
          "lactose_free",
          "high_protein",
        ],
        existing_disease: ["none", "diabetes", "heart_disease"],
      },
      disease_modifications: {
        diabetes: {
          description: "Modified for diabetic patients",
          substitutions: [
            {
              original: "Dates",
              replacement: "Figs",
              reason: "Lower sugar content",
            },
          ],
          portion_changes: "Reduce to 1/4 cup dates",
          additional_notes: "Increase flaxseeds for fiber",
        },
      },
      meal_timing: ["snack", "pre-workout"],
      compatibilityScore: 8,
    },
    totalMacros: {
      calories: "1951",
      protein: "61",
      carbs: "276",
      fats: "75",
    },
  },
  Friday: {
    breakfast: {
      id: "meal025",
      name: "Vegetable Oats Upma with Flaxseeds",
      description:
        "A nutritious South Indian-style upma made with oats, vegetables, and flaxseeds for added fiber and omega-3s.",
      region: "Indian",
      image_url: "https://example.com/images/vegetable_oats_upma.jpg",
      preparation_time_minutes: 20,
      difficulty_level: "Easy",
      is_ayurvedic: true,
      nutritional_info: {
        calories: 235,
        protein_grams: 8.9,
        carbs_grams: 39,
        fat_grams: 7,
        fiber_grams: 8.8,
        sodium_mg: 23,
        glycemic_index: "Medium",
        portion_size: "1 bowl (250g)",
      },
      ingredients: [
        {
          name: "Oats",
          quantity: "1/2 cup",
          substitutes: ["Broken wheat", "Quinoa"],
        },
        {
          name: "Flax seed",
          quantity: "1 tbsp",
          substitutes: ["Chia seeds", "Sesame seeds"],
        },
        {
          name: "Mixed Vegetables",
          quantity: "1/2 cup",
          substitutes: ["Only leafy greens", "Bell peppers"],
        },
      ],
      input_compatibility: {
        age: ["child", "teen", "adult", "senior"],
        gender: ["male", "female"],
        goal: ["weight_loss", "general_health"],
        activity: ["light", "moderate"],
        diet_type: [
          "vegetarian",
          "vegan",
          "jain",
          "sattvic",
          "gluten_free",
          "lactose_free",
          "high_protein",
        ],
        existing_disease: ["diabetes", "heart_disease"],
      },
      disease_modifications: {
        diabetes: {
          description: "Lower glycemic load for diabetics",
          substitutions: [
            {
              original: "Oats",
              replacement: "Broken wheat",
              reason: "Lower glycemic index",
            },
          ],
          portion_changes: "Reduce oats to 1/3 cup",
          additional_notes: "Add extra flaxseeds for fiber",
        },
      },
      meal_timing: ["breakfast", "snack"],
      compatibilityScore: 14,
    },
    lunch: {
      id: "meal031",
      name: "Grilled Chicken with Roasted Vegetables",
      description:
        "A protein-rich meal of grilled chicken breast served with a mix of roasted vegetables for a balanced diet.",
      region: "Global",
      image_url: "https://example.com/images/grilled_chicken_veggies.jpg",
      preparation_time_minutes: 30,
      difficulty_level: "Easy",
      is_ayurvedic: false,
      nutritional_info: {
        calories: 377,
        protein_grams: 44,
        carbs_grams: 6.3,
        fat_grams: 18.8,
        fiber_grams: 1.2,
        sodium_mg: 325,
        glycemic_index: "Low",
        portion_size: "1 plate (300g)",
      },
      ingredients: [
        {
          name: "Chicken Breast",
          quantity: "150g",
          substitutes: ["Turkey", "Paneer"],
        },
        {
          name: "Bell Peppers",
          quantity: "1/2 cup",
          substitutes: ["Zucchini", "Mushrooms"],
        },
        {
          name: "Olive Oil",
          quantity: "1 tbsp",
          substitutes: ["Coconut oil", "Butter"],
        },
      ],
      input_compatibility: {
        age: ["teen", "adult"],
        gender: ["male", "female"],
        goal: ["muscle_gain", "weight_loss"],
        activity: ["high"],
        diet_type: ["non_vegetarian", "high_protein"],
        existing_disease: ["none", "diabetes"],
      },
      disease_modifications: {},
      meal_timing: ["lunch", "dinner"],
      compatibilityScore: 10,
    },
    dinner: {
      id: "meal035",
      name: "Sautéed Mushrooms & Tofu with Brown Rice",
      description:
        "A delicious and protein-packed meal featuring sautéed mushrooms and tofu served over brown rice.",
      region: "Asian",
      image_url: "https://example.com/images/mushroom_tofu_rice.jpg",
      preparation_time_minutes: 20,
      difficulty_level: "Easy",
      is_ayurvedic: false,
      nutritional_info: {
        calories: 304,
        protein_grams: 26.5,
        carbs_grams: 28.24,
        fat_grams: 12,
        fiber_grams: 4.5,
        sodium_mg: 23.6,
        glycemic_index: "Medium",
        portion_size: "1 bowl (280g)",
      },
      ingredients: [
        {
          name: "Mushrooms",
          quantity: "1 cup",
          substitutes: ["Bell peppers", "Zucchini"],
        },
        {
          name: "Tofu",
          quantity: "1/2 cup",
          substitutes: ["Paneer", "Tempeh"],
        },
        {
          name: "Brown Rice",
          quantity: "1/2 cup",
          substitutes: ["Quinoa", "Wild rice"],
        },
      ],
      input_compatibility: {
        age: ["teen", "adult", "senior"],
        gender: ["male", "female"],
        goal: ["muscle_gain", "general_health"],
        activity: ["moderate", "high"],
        diet_type: [
          "vegetarian",
          "vegan",
          "gluten_free",
          "lactose_free",
          "high_protein",
        ],
        existing_disease: ["diabetes", "heart_disease"],
      },
      disease_modifications: {
        diabetes: {
          description: "Modified for diabetic patients",
          substitutions: [
            {
              original: "Brown Rice",
              replacement: "Quinoa",
              reason: "Lower glycemic impact",
            },
          ],
          portion_changes: "Reduce rice portion slightly",
          additional_notes: "Add more fiber-rich veggies",
        },
      },
      meal_timing: ["lunch", "dinner"],
      compatibilityScore: 4,
    },
    morningSnack: {
      id: "meal017",
      name: "Plain Yogurt with Seasonal Fruits",
      description:
        "A simple and refreshing snack or light meal consisting of plain yogurt topped with fresh, seasonal fruits.",
      region: "Pan-India",
      image_url: "https://example.com/images/yogurt_fruit.jpg",
      preparation_time_minutes: 5,
      difficulty_level: "Very Easy",
      is_ayurvedic: true,
      nutritional_info: {
        calories: 226,
        protein_grams: 9,
        carbs_grams: 25.8,
        fat_grams: 8,
        fiber_grams: 1.6,
        sodium_mg: 113.6,
        glycemic_index: "Low to Medium",
        portion_size: "1 cup yogurt (200g) with 1/2 cup fruit",
      },
      ingredients: [
        {
          name: "Yogurt",
          quantity: "1 cup",
          substitutes: ["Greek Yogurt"],
        },
        {
          name: "Seasonal Fruits",
          quantity: "1/2 cup (chopped)",
          substitutes: ["Apple, Orange"],
        },
        {
          name: "Honey",
          quantity: "1 tsp",
          substitutes: ["Maple Syrup"],
        },
      ],
      input_compatibility: {
        age: ["teen", "adult", "senior"],
        gender: ["male", "female"],
        goal: ["quick_meal", "light_snack"],
        activity: ["light"],
        diet_type: [
          "vegetarian",
          "eggetarian",
          "sattvic",
          "gluten_free",
          "high_protein",
        ],
        existing_disease: ["digestive_disorders", "diabetes"],
      },
      disease_modifications: {
        digestive_disorders: {
          description: "Easy to digest",
          substitutions: ["Use plain yogurt"],
          portion_changes: "Moderate portion",
          additional_notes: "Yogurt is good for gut health",
        },
        diabetes: {
          description: "Diabetic-friendly snack",
          substitutions: ["Choose low-glycemic fruits, limit added sweeteners"],
          portion_changes: "Monitor fruit intake",
          additional_notes: "Yogurt provides protein",
        },
        weight_management: {
          description: "Light and filling snack",
          substitutions: ["Use low-fat yogurt"],
          portion_changes: "A good snack option",
        },
      },
      meal_timing: ["snack", "breakfast"],
      compatibilityScore: 8,
    },
    eveningSnack: {
      id: "meal025",
      name: "Vegetable Oats Upma with Flaxseeds",
      description:
        "A nutritious South Indian-style upma made with oats, vegetables, and flaxseeds for added fiber and omega-3s.",
      region: "Indian",
      image_url: "https://example.com/images/vegetable_oats_upma.jpg",
      preparation_time_minutes: 20,
      difficulty_level: "Easy",
      is_ayurvedic: true,
      nutritional_info: {
        calories: 235,
        protein_grams: 8.9,
        carbs_grams: 39,
        fat_grams: 7,
        fiber_grams: 8.8,
        sodium_mg: 23,
        glycemic_index: "Medium",
        portion_size: "1 bowl (250g)",
      },
      ingredients: [
        {
          name: "Oats",
          quantity: "1/2 cup",
          substitutes: ["Broken wheat", "Quinoa"],
        },
        {
          name: "Flax seed",
          quantity: "1 tbsp",
          substitutes: ["Chia seeds", "Sesame seeds"],
        },
        {
          name: "Mixed Vegetables",
          quantity: "1/2 cup",
          substitutes: ["Only leafy greens", "Bell peppers"],
        },
      ],
      input_compatibility: {
        age: ["child", "teen", "adult", "senior"],
        gender: ["male", "female"],
        goal: ["weight_loss", "general_health"],
        activity: ["light", "moderate"],
        diet_type: [
          "vegetarian",
          "vegan",
          "jain",
          "sattvic",
          "gluten_free",
          "lactose_free",
          "high_protein",
        ],
        existing_disease: ["diabetes", "heart_disease"],
      },
      disease_modifications: {
        diabetes: {
          description: "Lower glycemic load for diabetics",
          substitutions: [
            {
              original: "Oats",
              replacement: "Broken wheat",
              reason: "Lower glycemic index",
            },
          ],
          portion_changes: "Reduce oats to 1/3 cup",
          additional_notes: "Add extra flaxseeds for fiber",
        },
      },
      meal_timing: ["breakfast", "snack"],
      compatibilityScore: 14,
    },
    totalMacros: {
      calories: "1377",
      protein: "97",
      carbs: "138",
      fats: "53",
    },
  },
  Saturday: {
    breakfast: {
      id: "meal004",
      name: "Sprouted Moong Salad with Lemon Dressing",
      description:
        "A refreshing and protein-rich sprouted moong dal salad with fresh veggies and a zesty lemon dressing.",
      region: "Indian",
      image_url: "https://example.com/images/sprouted_moong_salad.jpg",
      preparation_time_minutes: 15,
      difficulty_level: "Easy",
      is_ayurvedic: true,
      nutritional_info: {
        calories: 120,
        protein_grams: 9.2,
        carbs_grams: 21,
        fat_grams: 0.5,
        fiber_grams: 5,
        sodium_mg: 20,
        glycemic_index: "Low",
        portion_size: "1 medium bowl (200g)",
      },
      ingredients: [
        {
          name: "Sprouted Moong Dal",
          quantity: "100g",
          substitutes: ["Chickpeas", "Lentils"],
        },
        {
          name: "Cucumber",
          quantity: "50g",
          substitutes: ["Zucchini"],
        },
        {
          name: "Tomato",
          quantity: "50g",
          substitutes: ["Cherry tomatoes"],
        },
        {
          name: "Lemon Juice",
          quantity: "1 tbsp",
          substitutes: ["Apple cider vinegar"],
        },
      ],
      input_compatibility: {
        age: ["child", "teen", "adult", "senior"],
        gender: ["male", "female"],
        goal: ["weight_loss", "general_health"],
        activity: ["sedentary", "light", "moderate"],
        diet_type: [
          "vegetarian",
          "jain",
          "sattvic",
          "gluten_free",
          "high_protein",
          "lactose_free",
          "vegan",
          "keto",
        ],
        existing_disease: [
          "none",
          "diabetes",
          "hypertension",
          "digestive_disorders",
        ],
      },
      disease_modifications: {
        diabetes: {
          description: "Diabetic-friendly meal",
          substitutions: [],
          portion_changes: "No change",
          additional_notes: "Avoid adding sweet dressings",
        },
        hypertension: {
          description: "Low-sodium version",
          substitutions: [],
          portion_changes: "Use minimal salt",
          additional_notes: "Increase cucumber for hydration",
        },
      },
      meal_timing: ["breakfast", "snack"],
      compatibilityScore: 14,
    },
    lunch: {
      id: "meal033",
      name: "Quinoa & Vegetable Stir-Fry with Peanuts",
      description:
        "A protein-rich stir-fry featuring quinoa, colorful vegetables, and crunchy peanuts for a nutritious and satisfying meal.",
      region: "Global",
      image_url: "https://example.com/images/quinoa_vegetable_stir_fry.jpg",
      preparation_time_minutes: 25,
      difficulty_level: "Medium",
      is_ayurvedic: true,
      nutritional_info: {
        calories: 385,
        protein_grams: 13.6,
        carbs_grams: 52.6,
        fat_grams: 9.2,
        fiber_grams: 12.2,
        sodium_mg: 41,
        glycemic_index: "Low",
        portion_size: "1 bowl (250g)",
      },
      ingredients: [
        {
          name: "Quinoa",
          quantity: "1 cup",
          substitutes: ["Brown rice", "Millet"],
        },
        {
          name: "Mixed Vegetables",
          quantity: "1 cup",
          substitutes: ["Broccoli", "Bell peppers"],
        },
        {
          name: "Peanuts",
          quantity: "2 tbsp",
          substitutes: ["Almonds", "Cashews"],
        },
      ],
      input_compatibility: {
        age: ["teen", "adult", "senior"],
        gender: ["male", "female"],
        goal: ["muscle_gain", "general_health"],
        activity: ["moderate", "high"],
        diet_type: [
          "vegetarian",
          "vegan",
          "gluten_free",
          "lactose_free",
          "high_protein",
        ],
        existing_disease: ["none", "diabetes", "heart_disease"],
      },
      disease_modifications: {
        diabetes: {
          description: "Modified for diabetic patients",
          substitutions: [
            {
              original: "Peanuts",
              replacement: "Almonds",
              reason: "Lower glycemic load",
            },
          ],
          portion_changes: "Reduce quinoa by 1/4 cup",
          additional_notes: "Increase fiber-rich vegetables",
        },
      },
      meal_timing: ["lunch", "dinner"],
      compatibilityScore: 4,
    },
    dinner: {
      id: "meal001",
      name: "Vegetable Dal Khichdi with Raita",
      description:
        "Nutritious one-pot meal with rice, lentils and mixed vegetables, served with yogurt side dish",
      region: "North Indian",
      image_url: "https://example.com/images/khichdi.jpg",
      preparation_time_minutes: 30,
      difficulty_level: "Easy",
      is_ayurvedic: true,
      nutritional_info: {
        calories: 308,
        protein_grams: 11.8,
        carbs_grams: 47.8,
        fat_grams: 5,
        fiber_grams: 8,
        sodium_mg: 1200,
        glycemic_index: "Medium",
        portion_size: "1 bowl (250g) khichdi, 1 small bowl (100g) raita",
      },
      ingredients: [
        {
          name: "Rice",
          quantity: "100g",
          substitutes: ["Brown rice", "Quinoa"],
        },
        {
          name: "Yellow Moong Dal",
          quantity: "50g",
          substitutes: ["Red lentils", "Toor dal"],
        },
        {
          name: "Mixed Vegetables",
          quantity: "100g",
          substitutes: ["Seasonal vegetables"],
        },
        {
          name: "Yogurt",
          quantity: "100g",
          substitutes: ["Plant-based yogurt"],
        },
        {
          name: "Ghee",
          quantity: "1 tsp",
          substitutes: ["Olive oil"],
        },
      ],
      input_compatibility: {
        age: ["child", "teen", "adult", "senior"],
        gender: ["male", "female"],
        goal: [
          "weight_maintenance",
          "weight_loss",
          "general_health",
          "health_management",
        ],
        activity: ["sedentary", "light", "moderate", "active"],
        diet_type: [
          "vegetarian",
          "jain",
          "sattvic",
          "gluten_free",
          "high_protein",
          "lactose_free",
        ],
        existing_disease: [
          "none",
          "diabetes",
          "hypertension",
          "digestive_disorders",
        ],
      },
      disease_modifications: {
        diabetes: {
          description: "Modified for diabetic patients",
          substitutions: [
            {
              original: "Rice",
              replacement: "Brown rice",
              reason: "Lower glycemic index",
            },
          ],
          portion_changes: "Reduce to 200g total serving",
          additional_notes: "Pair with more fiber-rich vegetables",
        },
        hypertension: {
          description: "Modified for hypertension patients",
          substitutions: [],
          portion_changes: "Standard portion, no added salt",
          additional_notes: "Use herbs and spices instead of salt for flavor",
        },
      },
      meal_timing: ["lunch", "dinner"],
      compatibilityScore: 14,
    },
    morningSnack: {
      id: "meal017",
      name: "Plain Yogurt with Seasonal Fruits",
      description:
        "A simple and refreshing snack or light meal consisting of plain yogurt topped with fresh, seasonal fruits.",
      region: "Pan-India",
      image_url: "https://example.com/images/yogurt_fruit.jpg",
      preparation_time_minutes: 5,
      difficulty_level: "Very Easy",
      is_ayurvedic: true,
      nutritional_info: {
        calories: 226,
        protein_grams: 9,
        carbs_grams: 25.8,
        fat_grams: 8,
        fiber_grams: 1.6,
        sodium_mg: 113.6,
        glycemic_index: "Low to Medium",
        portion_size: "1 cup yogurt (200g) with 1/2 cup fruit",
      },
      ingredients: [
        {
          name: "Yogurt",
          quantity: "1 cup",
          substitutes: ["Greek Yogurt"],
        },
        {
          name: "Seasonal Fruits",
          quantity: "1/2 cup (chopped)",
          substitutes: ["Apple, Orange"],
        },
        {
          name: "Honey",
          quantity: "1 tsp",
          substitutes: ["Maple Syrup"],
        },
      ],
      input_compatibility: {
        age: ["teen", "adult", "senior"],
        gender: ["male", "female"],
        goal: ["quick_meal", "light_snack"],
        activity: ["light"],
        diet_type: [
          "vegetarian",
          "eggetarian",
          "sattvic",
          "gluten_free",
          "high_protein",
        ],
        existing_disease: ["digestive_disorders", "diabetes"],
      },
      disease_modifications: {
        digestive_disorders: {
          description: "Easy to digest",
          substitutions: ["Use plain yogurt"],
          portion_changes: "Moderate portion",
          additional_notes: "Yogurt is good for gut health",
        },
        diabetes: {
          description: "Diabetic-friendly snack",
          substitutions: ["Choose low-glycemic fruits, limit added sweeteners"],
          portion_changes: "Monitor fruit intake",
          additional_notes: "Yogurt provides protein",
        },
        weight_management: {
          description: "Light and filling snack",
          substitutions: ["Use low-fat yogurt"],
          portion_changes: "A good snack option",
        },
      },
      meal_timing: ["snack", "breakfast"],
      compatibilityScore: 8,
    },
    eveningSnack: {
      id: "meal023",
      name: "Muesli Bowl with Mixed Nuts",
      description:
        "A fiber-rich breakfast bowl with muesli, mixed nuts, and milk or yogurt for sustained energy and nutrition.",
      region: "Western",
      image_url: "https://example.com/images/muesli_mixed_nuts.jpg",
      preparation_time_minutes: 5,
      difficulty_level: "Easy",
      is_ayurvedic: false,
      nutritional_info: {
        calories: 410,
        protein_grams: 15,
        carbs_grams: 60,
        fat_grams: 12,
        fiber_grams: 7,
        sodium_mg: 100,
        glycemic_index: "Medium",
        portion_size: "1 bowl (250g)",
      },
      ingredients: [
        {
          name: "Muesli",
          quantity: "1 cup",
          substitutes: ["Oats", "Granola"],
        },
        {
          name: "Mixed Nuts (Almonds, Walnuts, Cashews)",
          quantity: "2 tbsp",
          substitutes: ["Pumpkin seeds", "Sunflower seeds"],
        },
        {
          name: "Milk or Yogurt",
          quantity: "200ml",
          substitutes: ["Almond milk", "Coconut yogurt"],
        },
        {
          name: "Honey",
          quantity: "1 tsp",
          substitutes: ["Maple syrup", "Stevia (for diabetics)"],
        },
      ],
      input_compatibility: {
        age: ["child", "teen", "adult", "senior"],
        gender: ["male", "female"],
        goal: ["muscle_gain", "energy_boost", "general_health"],
        activity: ["moderate", "active"],
        diet_type: ["vegetarian", "eggetarian", "gluten_free", "high_protein"],
        existing_disease: ["none", "diabetes", "heart_disease"],
      },
      disease_modifications: {
        diabetes: {
          description: "Modified for diabetic patients",
          substitutions: [
            {
              original: "Honey",
              replacement: "Stevia",
              reason: "Lowers sugar intake",
            },
          ],
          portion_changes: "Reduce muesli to 3/4 cup",
          additional_notes: "Add more nuts for healthy fats",
        },
      },
      meal_timing: ["breakfast", "snack"],
      compatibilityScore: 4,
    },
    totalMacros: {
      calories: "1449",
      protein: "59",
      carbs: "207",
      fats: "35",
    },
  },
  Sunday: {
    breakfast: {
      id: "meal023",
      name: "Muesli Bowl with Mixed Nuts",
      description:
        "A fiber-rich breakfast bowl with muesli, mixed nuts, and milk or yogurt for sustained energy and nutrition.",
      region: "Western",
      image_url: "https://example.com/images/muesli_mixed_nuts.jpg",
      preparation_time_minutes: 5,
      difficulty_level: "Easy",
      is_ayurvedic: false,
      nutritional_info: {
        calories: 410,
        protein_grams: 15,
        carbs_grams: 60,
        fat_grams: 12,
        fiber_grams: 7,
        sodium_mg: 100,
        glycemic_index: "Medium",
        portion_size: "1 bowl (250g)",
      },
      ingredients: [
        {
          name: "Muesli",
          quantity: "1 cup",
          substitutes: ["Oats", "Granola"],
        },
        {
          name: "Mixed Nuts (Almonds, Walnuts, Cashews)",
          quantity: "2 tbsp",
          substitutes: ["Pumpkin seeds", "Sunflower seeds"],
        },
        {
          name: "Milk or Yogurt",
          quantity: "200ml",
          substitutes: ["Almond milk", "Coconut yogurt"],
        },
        {
          name: "Honey",
          quantity: "1 tsp",
          substitutes: ["Maple syrup", "Stevia (for diabetics)"],
        },
      ],
      input_compatibility: {
        age: ["child", "teen", "adult", "senior"],
        gender: ["male", "female"],
        goal: ["muscle_gain", "energy_boost", "general_health"],
        activity: ["moderate", "active"],
        diet_type: ["vegetarian", "eggetarian", "gluten_free", "high_protein"],
        existing_disease: ["none", "diabetes", "heart_disease"],
      },
      disease_modifications: {
        diabetes: {
          description: "Modified for diabetic patients",
          substitutions: [
            {
              original: "Honey",
              replacement: "Stevia",
              reason: "Lowers sugar intake",
            },
          ],
          portion_changes: "Reduce muesli to 3/4 cup",
          additional_notes: "Add more nuts for healthy fats",
        },
      },
      meal_timing: ["breakfast", "snack"],
      compatibilityScore: 4,
    },
    lunch: {
      id: "meal013",
      name: "Spicy Peanut & Vegetable Stir-Fry with Brown Rice",
      description:
        "A flavorful and quick stir-fry featuring a medley of Indian vegetables and a generous amount of peanuts for protein and crunch, served with wholesome brown rice.",
      region: "Pan-India",
      image_url: "https://example.com/images/peanut_vegetable_stirfry.jpg",
      preparation_time_minutes: 25,
      difficulty_level: "Easy",
      is_ayurvedic: true,
      nutritional_info: {
        calories: 476,
        protein_grams: 17.5,
        carbs_grams: 56.5,
        fat_grams: 20.5,
        fiber_grams: 7.5,
        sodium_mg: 4,
        glycemic_index: "Medium",
        portion_size: "1.5 cups (300g)",
      },
      ingredients: [
        {
          name: "Brown Rice (cooked)",
          quantity: "1 cup",
          substitutes: ["Quinoa", "Whole Wheat Noodles"],
        },
        {
          name: "Mixed Vegetables",
          quantity: "1 cups",
          substitutes: ["Cauliflower, Broccoli"],
        },
        {
          name: "Peanuts",
          quantity: "1/4 cup",
          substitutes: ["Cashews", "Almonds"],
        },
        {
          name: "Green Chili",
          quantity: "1/2 tsp",
          substitutes: ["Red Chili Powder"],
        },
      ],
      input_compatibility: {
        age: ["adult", "senior"],
        gender: ["male", "female"],
        goal: ["balanced_diet", "protein_intake", "quick_meal"],
        activity: ["moderate"],
        diet_type: [
          "vegetarian",
          "vegan",
          "jain",
          "sattvic",
          "gluten_free",
          "lactose_free",
          "high_protein",
        ],
        existing_disease: ["diabetes", "hypertension"],
      },
      disease_modifications: {
        diabetes: {
          description: "Diabetic-friendly stir-fry",
          substitutions: ["Increase non-starchy vegetables, use less rice"],
          portion_changes: "Monitor rice portion, pair with more vegetables",
          additional_notes:
            "Peanuts provide healthy fats and protein, which can help manage blood sugar",
        },
        hypertension: {
          description: "Low-sodium stir-fry",
          substitutions: ["Use low-sodium soy sauce or tamari, reduce salt"],
          portion_changes: "No change",
          additional_notes: "Focus on fresh herbs for flavor",
        },
        weight_management: {
          description: "Healthy and filling meal",
          substitutions: ["Use more vegetables, less rice"],
          portion_changes: "Reduce rice portion to 3/4 cup",
          additional_notes:
            "Protein and fiber from peanuts and vegetables promote satiety",
        },
      },
      meal_timing: ["lunch", "dinner"],
      compatibilityScore: 4,
    },
    dinner: {
      id: "meal034",
      name: "Palak Moong Dal with Multigrain Roti",
      description:
        "A wholesome dish made with spinach and protein-packed moong dal, served with nutritious multigrain roti.",
      region: "Indian",
      image_url: "https://example.com/images/palak_moong_dal.jpg",
      preparation_time_minutes: 30,
      difficulty_level: "Medium",
      is_ayurvedic: true,
      nutritional_info: {
        calories: 267,
        protein_grams: 16.5,
        carbs_grams: 46.2,
        fat_grams: 3.9,
        fiber_grams: 15,
        sodium_mg: 126,
        glycemic_index: "Medium",
        portion_size: "1 serving (300g)",
      },
      ingredients: [
        {
          name: "Moong Dal",
          quantity: "1/2 cup",
          substitutes: ["Masoor dal", "Toor dal"],
        },
        {
          name: "Spinach",
          quantity: "1 cup",
          substitutes: ["Fenugreek leaves", "Amaranth leaves"],
        },
        {
          name: "Multigrain Roti",
          quantity: "1 piece",
          substitutes: ["Whole wheat roti", "Oats roti"],
        },
      ],
      input_compatibility: {
        age: ["child", "teen", "adult", "senior"],
        gender: ["male", "female"],
        goal: ["muscle_gain", "weight_maintenance"],
        activity: ["light", "moderate"],
        diet_type: [
          "vegetarian",
          "eggetarian",
          "jain",
          "sattvic",
          "gluten_free",
          "high_protein",
        ],
        existing_disease: ["diabetes", "heart_disease"],
      },
      disease_modifications: {
        diabetes: {
          description: "Modified for diabetic patients",
          substitutions: [
            {
              original: "Multigrain Roti",
              replacement: "Oats roti",
              reason: "Lower glycemic response",
            },
          ],
          portion_changes: "Reduce dal portion slightly",
          additional_notes: "Increase fiber-rich greens",
        },
      },
      meal_timing: ["lunch", "dinner"],
      compatibilityScore: 8,
    },
    morningSnack: {
      id: "meal022",
      name: "Poha with Flaxseeds & Peanuts",
      description:
        "A light and nutritious flattened rice dish enriched with flaxseeds and crunchy peanuts for a protein and fiber boost.",
      region: "Indian",
      image_url: "https://example.com/images/poha_flaxseeds_peanuts.jpg",
      preparation_time_minutes: 15,
      difficulty_level: "Easy",
      is_ayurvedic: true,
      nutritional_info: {
        calories: 292,
        protein_grams: 8.5,
        carbs_grams: 45.7,
        fat_grams: 10.3,
        fiber_grams: 4.6,
        sodium_mg: 64,
        glycemic_index: "Medium",
        portion_size: "1 bowl (250g)",
      },
      ingredients: [
        {
          name: "Flattened Rice (Poha)",
          quantity: "1 cup",
          substitutes: ["Brown rice flakes", "Quinoa flakes"],
        },
        {
          name: "Flax seed",
          quantity: "1 tbsp",
          substitutes: ["Chia seeds", "Sunflower seeds"],
        },
        {
          name: "Peanuts",
          quantity: "2 tbsp",
          substitutes: ["Almonds", "Cashews"],
        },
        {
          name: "Turmeric",
          quantity: "1/4 tsp",
          substitutes: ["Saffron", "Paprika"],
        },
      ],
      input_compatibility: {
        age: ["teen", "adult", "senior"],
        gender: ["male", "female"],
        goal: ["weight_maintenance", "general_health", "energy_boost"],
        activity: ["light", "moderate"],
        diet_type: [
          "vegetarian",
          "jain",
          "sattvic",
          "gluten_free",
          "lactose_free",
          "high_protein",
        ],
        existing_disease: ["none", "diabetes", "heart_disease"],
      },
      disease_modifications: {
        diabetes: {
          description: "Modified for diabetic patients",
          substitutions: [
            {
              original: "Flattened Rice (Poha)",
              replacement: "Brown rice flakes",
              reason: "Lower glycemic index",
            },
          ],
          portion_changes: "Reduce to 3/4 cup poha",
          additional_notes: "Add extra flaxseeds for fiber",
        },
      },
      meal_timing: ["breakfast", "snack"],
      compatibilityScore: 8,
    },
    eveningSnack: {
      id: "meal024",
      name: "Almond & Dates Energy Bars",
      description:
        "A naturally sweetened, no-bake energy bar packed with almonds, dates, and seeds for a quick, healthy snack.",
      region: "Global",
      image_url: "https://example.com/images/almond_dates_bar.jpg",
      preparation_time_minutes: 10,
      difficulty_level: "Easy",
      is_ayurvedic: true,
      nutritional_info: {
        calories: 752,
        protein_grams: 14.3,
        carbs_grams: 74.5,
        fat_grams: 48.7,
        fiber_grams: 11.5,
        sodium_mg: 1,
        glycemic_index: "Medium",
        portion_size: "1 bar (50g)",
      },
      ingredients: [
        {
          name: "Almonds",
          quantity: "1/2 cup",
          substitutes: ["Cashews", "Walnuts"],
        },
        {
          name: "Dates",
          quantity: "1/2 cup",
          substitutes: ["Figs", "Raisins"],
        },
        {
          name: "Flax seed",
          quantity: "1 tbsp",
          substitutes: ["Chia seeds", "Pumpkin seeds"],
        },
        {
          name: "Coconut Oil",
          quantity: "1 tbsp",
          substitutes: ["Ghee", "Peanut butter"],
        },
      ],
      input_compatibility: {
        age: ["child", "teen", "adult", "senior"],
        gender: ["male", "female"],
        goal: ["energy_boost", "weight_maintenance", "general_health"],
        activity: ["light", "moderate"],
        diet_type: [
          "vegetarian",
          "vegan",
          "jain",
          "sattvic",
          "gluten_free",
          "lactose_free",
          "high_protein",
        ],
        existing_disease: ["none", "diabetes", "heart_disease"],
      },
      disease_modifications: {
        diabetes: {
          description: "Modified for diabetic patients",
          substitutions: [
            {
              original: "Dates",
              replacement: "Figs",
              reason: "Lower sugar content",
            },
          ],
          portion_changes: "Reduce to 1/4 cup dates",
          additional_notes: "Increase flaxseeds for fiber",
        },
      },
      meal_timing: ["snack", "pre-workout"],
      compatibilityScore: 8,
    },
    totalMacros: {
      calories: "2197",
      protein: "72",
      carbs: "283",
      fats: "95",
    },
  },
};

/*
 * Fetch Meal list from database
 */
async function fetchMealData() {
  try {
    if (!window.mealDataUrl) {
      throw new Error("Meal data URL is not defined.");
    }

    const response = await fetch(window.mealDataUrl);
    const mealData = await response.json();
    return mealData;
  } catch (error) {
    console.error("Error fetching meal data:", error);
  }
}

/**
 * Generates a personalized weekly diet chart based on user inputs
 * @param {Object} userInputs - User profile inputs
 * @param {string} userInputs.age - User's age category
 * @param {string} userInputs.gender - User's gender
 * @param {string} userInputs.goal - User's health/fitness goal
 * @param {string} userInputs.activity - User's activity level
 * @param {string} userInputs.dietType - User's dietary preference
 * @param {string} userInputs.existingDisease - User's health condition (if any)
 * @param {Array} mealDatabase - Database of meal options
 * @returns {Object} Weekly diet chart with meal recommendations
 */

window.generateDietPlan = async function (userFilters) {
  const {
    age,
    gender,
    weight,
    goal,
    activity,
    condition,
    diet,
    firstName,
    lastName,
  } = userFilters;
  userName = `${firstName} ${lastName}`;
  const mealDatabase = await fetchMealData();

  // Helper function to handle multiple conditions
  const processConditions = (conditions) => {
    // If conditions is a string, convert to array
    const conditionArray = Array.isArray(conditions)
      ? conditions
      : conditions
      ? [conditions]
      : ["none"];

    // Map conditions to standardized database values
    const conditionMapping = {
      diabetes: "diabetes",
      diabetics: "diabetes",
      hypertension: "hypertension",
      heart_disease: "heart_disease",
      obesity: "obesity",
      thyroid: "hypothyroidism",
      pcos: "pcos",
      digestive_disorders: "digestive_disorders",
      lactose_intolerance: "lactose_intolerance",
      gluten_allergy: "gluten_sensitivity",
      kidney_disease: "kidney_disease",
      anemia: "anemia",
    };

    // Standardize and filter out invalid conditions
    return conditionArray
      .map((cond) => conditionMapping[cond.toLowerCase()] || cond.toLowerCase())
      .filter((cond) => cond !== "none" && cond !== undefined);
  };

  // Process conditions
  const processedConditions = processConditions(condition);
  const userInputs = {
    age: getAgeGroup(age),
    gender,
    goal,
    activity,
    dietType: diet,
    // Use 'none' if no valid conditions, otherwise use first condition
    existingDisease:
      processedConditions.length > 0 ? processedConditions[0] : "none",
  };

  // 1. Map raw user inputs to standardized values
  const mappedInputs = mapUserInputs(userInputs);

  // 2. Filter meals based on user inputs with priority on health conditions
  const compatibleMeals = filterCompatibleMeals(mappedInputs, mealDatabase);

  // 3. Categorize filtered meals by meal timing
  const categorizedMeals = categorizeMealsByTiming(compatibleMeals);

  // 4. Generate a balanced weekly plan
  const weeklyPlan = createWeeklyPlan(
    mappedInputs,
    categorizedMeals,
    mealDatabase
  );

  // 5. Apply any disease-specific modifications
  const finalPlan = applyDiseaseModifications(
    weeklyPlan,
    mappedInputs.existingDiseases,
    mealDatabase
  );

  return generateDietTable(finalPlan);
};

/**
 * Filter age group
 */
const getAgeGroup = (age) => {
  if (age >= 0 && age <= 12) return "0-12";
  if (age >= 13 && age <= 19) return "13-19";
  if (age >= 20 && age <= 59) return "20-59";
  if (age >= 60) return "60+";
  return "60+";
};

/**
 * Maps raw user input values to standardized values used in the meal database
 */
function mapUserInputs(rawInputs) {
  // Input mapping definitions (simplified version)
  const inputMapping = {
    age: {
      "0-12": "child",
      "13-19": "teen",
      "20-59": "adult",
      "60+": "senior",
    },
    gender: {
      male: "male",
      female: "female",
    },
    goal: {
      weight_loss: "weight_loss",
      weight_gain: "weight_gain",
      muscle_building: "muscle_gain",
      maintenance: "weight_maintenance",
      general_health: "general_health",
      disease_management: "health_management",
    },
    activity: {
      sedentary: "sedentary",
      light: "light",
      moderate: "moderate",
      active: "active",
      very_active: "very_active",
    },
    dietType: {
      vegetarian: "vegetarian",
      vegan: "vegan",
      non_vegetarian: "non_vegetarian",
      eggetarian: "eggetarian",
      jain: "jain",
      sattvic: "sattvic",
      keto: "keto",
      gluten_free: "gluten_free",
      lactose_free: "lactose_free",
      high_protein: "high_protein",
    },
    existingDisease: {
      none: "none",
      diabetes: "diabetes",
      hypertension: "hypertension",
      heart_disease: "heart_disease",
      obesity: "obesity",
      thyroid: "hypothyroidism",
      pcos: "pcos",
      digestive_disorders: "digestive_disorders",
      lactose_intolerance: "lactose_intolerance",
      gluten_allergy: "gluten_sensitivity",
      kidney_disease: "kidney_disease",
      anemia: "anemia",
    },
  };

  return {
    age: inputMapping.age[rawInputs.age] || rawInputs.age,
    gender: inputMapping.gender[rawInputs.gender] || rawInputs.gender,
    goal: inputMapping.goal[rawInputs.goal] || rawInputs.goal,
    activity: inputMapping.activity[rawInputs.activity] || rawInputs.activity,
    dietType: inputMapping.dietType[rawInputs.dietType] || rawInputs.dietType,
    existingDisease:
      inputMapping.existingDisease[rawInputs.existingDisease] ||
      rawInputs.existingDisease,
  };
}

/**
 * Filters meals from database that are compatible with user inputs
 */
const filterCompatibleMeals = (mappedInputs, mealDatabase) => {
  // Define priority scoring for meal compatibility
  const priorityWeights = {
    existingDisease: 10,
    dietType: 8,
    goal: 6,
    activity: 4,
    age: 3,
    gender: 1,
  };

  // Filter and score compatible meals
  return mealDatabase
    .filter((meal) => {
      // Hard filter: Must match diet type and be compatible with health condition
      const isDietCompatible = meal.input_compatibility.diet_type.includes(
        mappedInputs.dietType
      );
      // Ensure compatibility with the primary condition
      const isDiseaseCompatible =
        mappedInputs.existingDisease === "none" ||
        meal.input_compatibility.existing_disease.includes(
          mappedInputs.existingDisease
        );

      if (!isDietCompatible || !isDiseaseCompatible) {
        return false;
      }

      // Calculate compatibility score for other factors
      let compatibilityScore = 0;

      if (meal.input_compatibility.age.includes(mappedInputs.age)) {
        compatibilityScore += priorityWeights.age;
      }

      if (meal.input_compatibility.gender.includes(mappedInputs.gender)) {
        compatibilityScore += priorityWeights.gender;
      }

      if (meal.input_compatibility.goal.includes(mappedInputs.goal)) {
        compatibilityScore += priorityWeights.goal;
      }

      if (meal.input_compatibility.activity.includes(mappedInputs.activity)) {
        compatibilityScore += priorityWeights.activity;
      }

      // Add compatibility score to meal object for later sorting
      meal.compatibilityScore = compatibilityScore;

      return compatibilityScore > 0;
    })
    .sort((a, b) => b.compatibilityScore - a.compatibilityScore);
};

/**
 * Categorizes meals by meal timing (breakfast, lunch, dinner, snacks)
 */
function categorizeMealsByTiming(compatibleMeals) {
  const categorized = {
    breakfast: [],
    lunch: [],
    dinner: [],
    snack: [],
  };

  compatibleMeals.forEach((meal) => {
    meal.meal_timing.forEach((timing) => {
      if (categorized[timing]) {
        categorized[timing].push({ ...meal });
      }
    });
  });

  return categorized;
}

/**
 * Creates a balanced weekly meal plan with variety
 */
function createWeeklyPlan(userProfile, categorizedMeals, mealDatabase) {
  const days = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];
  const weeklyPlan = {};

  // Track used meals across the entire week to ensure maximum uniqueness
  const usedMeals = {
    breakfast: new Set(),
    lunch: new Set(),
    dinner: new Set(),
    snack: new Set(),
  };

  // Enhanced meal selection function prioritizing uniqueness
  const getUniqueMeal = (
    mealCategory,
    usedMealIds,
    maxAllowedRepetitions = 1
  ) => {
    if (categorizedMeals[mealCategory].length === 0) return null;

    // First, find meals that haven't been used at all
    const completlyUnusedMeals = categorizedMeals[mealCategory].filter(
      (meal) => !usedMealIds.has(meal.id)
    );

    if (completlyUnusedMeals.length > 0) {
      const selectedMeal = selectBestMeal(completlyUnusedMeals);
      usedMealIds.add(selectedMeal.id);
      return selectedMeal;
    }

    // If all meals have been used, find those used least
    const mealUsageCounts = {};
    usedMealIds.forEach((mealId) => {
      mealUsageCounts[mealId] = (mealUsageCounts[mealId] || 0) + 1;
    });

    // Find meals used fewer times than max allowed repetitions
    const availableMeals = categorizedMeals[mealCategory].filter(
      (meal) => (mealUsageCounts[meal.id] || 0) < maxAllowedRepetitions
    );

    if (availableMeals.length > 0) {
      const selectedMeal = selectBestMeal(availableMeals);
      usedMealIds.add(selectedMeal.id);
      return selectedMeal;
    }

    // Fallback: if no meals meet uniqueness criteria, return a random meal
    const fallbackMeal = selectBestMeal(categorizedMeals[mealCategory]);
    usedMealIds.add(fallbackMeal.id);
    return fallbackMeal;
  };

  // Helper function to select the best meal based on compatibility score
  const selectBestMeal = (mealArray) => {
    // Get a weighted random meal based on compatibility score
    const totalScore = mealArray.reduce(
      (sum, meal) => sum + (meal.compatibilityScore || 1),
      0
    );
    let random = Math.random() * totalScore;

    for (let meal of mealArray) {
      random -= meal.compatibilityScore || 1;
      if (random <= 0) return meal;
    }

    return mealArray[0];
  };

  const getRandomMeal = (mealType) => {
    const meals = mealDatabase.filter((meal) =>
      meal.meal_timing.includes(mealType)
    );
    return meals.length > 0
      ? meals[Math.floor(Math.random() * meals.length)]
      : null;
  };

  // Create plan for each day
  days.forEach((day) => {
    // Get meals for this day with enhanced uniqueness
    const breakfast =
      getUniqueMeal("breakfast", usedMeals.breakfast) ||
      getRandomMeal("breakfast");
    const lunch =
      getUniqueMeal("lunch", usedMeals.lunch) || getRandomMeal("lunch");
    const dinner =
      getUniqueMeal("dinner", usedMeals.dinner) || getRandomMeal("dinner");
    const morningSnack =
      getUniqueMeal("snack", usedMeals.snack) || getRandomMeal("snack");
    const eveningSnack =
      getUniqueMeal("snack", usedMeals.snack) || getRandomMeal("snack");

    // Calculate total macros for the day
    const meals = [breakfast, morningSnack, lunch, eveningSnack, dinner];
    const totalMacros = meals.reduce(
      (acc, meal) => {
        if (meal && meal.nutritional_info) {
          acc.calories += meal.nutritional_info.calories || 0;
          acc.protein += meal.nutritional_info.protein_grams || 0;
          acc.carbs += meal.nutritional_info.carbs_grams || 0;
          acc.fats += meal.nutritional_info.fat_grams || 0;
        }
        return acc;
      },
      { calories: 0, protein: 0, carbs: 0, fats: 0 }
    );

    weeklyPlan[day] = {
      breakfast: breakfast || {
        name: "Default healthy breakfast",
        description: "Not enough matching options in database",
        ingredients: [{ name: "", quantity: "" }],
      },
      lunch: lunch || {
        name: "Default healthy lunch",
        description: "Not enough matching options in database",
        ingredients: [{ name: "", quantity: "" }],
      },
      dinner: dinner || {
        name: "Default healthy dinner",
        description: "Not enough matching options in database",
        ingredients: [{ name: "", quantity: "" }],
      },
      morningSnack: morningSnack || {
        name: "Fruit or nuts",
        description: "Seasonal fruit or mixed nuts",
        ingredients: [{ name: "", quantity: "" }],
      },
      eveningSnack: eveningSnack || {
        name: "Herbal tea",
        description: "Herbal tea with minimal sweetener",
        ingredients: [{ name: "", quantity: "" }],
      },
      totalMacros: {
        calories: totalMacros.calories.toFixed(0),
        protein: totalMacros.protein.toFixed(0),
        carbs: totalMacros.carbs.toFixed(0),
        fats: totalMacros.fats.toFixed(0),
      },
    };
  });

  return {
    userProfile,
    weeklyPlan,
  };
}

/**
 * Applies disease-specific modifications to meals in the plan
 */
function applyDiseaseModifications(weeklyPlan, disease, mealDatabase) {
  if (disease === "none") {
    return weeklyPlan;
  }

  const modifiedPlan = { ...weeklyPlan };
  const days = Object.keys(modifiedPlan.weeklyPlan);

  days.forEach((day) => {
    const dayPlan = modifiedPlan.weeklyPlan[day];
    const mealTypes = Object.keys(dayPlan);

    mealTypes.forEach((mealType) => {
      const meal = dayPlan[mealType];

      // Skip default meals
      if (!meal.id) return;

      // Find original meal in database to get disease modifications
      const originalMeal = mealDatabase.find((m) => m.id === meal.id);
      if (!originalMeal) return;

      // Apply disease modifications if available
      if (
        originalMeal.disease_modifications &&
        originalMeal.disease_modifications[disease]
      ) {
        const modifications = originalMeal.disease_modifications[disease];

        // Merge existing modifications or create new
        meal.modifications = meal.modifications || {};

        // Update modifications with disease-specific details
        meal.modifications = {
          description: modifications.description,
          substitutions:
            modifications.substitutions || meal.modifications.substitutions,
          portionChanges:
            modifications.portion_changes || meal.modifications.portionChanges,
          additionalNotes:
            (meal.modifications.additionalNotes || "") +
            (modifications.additional_notes
              ? ` Additional notes for ${disease}: ${modifications.additional_notes}`
              : ""),
        };
      }
    });
  });

  return modifiedPlan;
}

/**
 * Format diet chart into a user-friendly display format
 */
function formatDietChart(dietPlan) {
  const formattedPlan = {
    userProfile: dietPlan.userProfile,
    weeklySchedule: {},
  };

  Object.keys(dietPlan.weeklyPlan).forEach((day) => {
    const dayPlan = dietPlan.weeklyPlan[day];

    // Calculate daily total macros
    const dailyMacros = {
      totalCalories: 0,
      totalProtein: 0,
      totalCarbs: 0,
      totalFat: 0,
    };

    ["breakfast", "morningSnack", "lunch", "eveningSnack", "dinner"].forEach(
      (mealType) => {
        const meal = dayPlan[mealType];
        if (meal && meal.nutritional_info) {
          dailyMacros.totalCalories += meal.nutritional_info.calories;
          dailyMacros.totalProtein += meal.nutritional_info.protein_grams;
          dailyMacros.totalCarbs += meal.nutritional_info.carbs_grams;
          dailyMacros.totalFat += meal.nutritional_info.fat_grams;
        }
      }
    );

    formattedPlan.weeklySchedule[day] = {
      breakfast: formatMeal(dayPlan.breakfast),
      morningSnack: formatMeal(dayPlan.morningSnack),
      lunch: formatMeal(dayPlan.lunch),
      eveningSnack: formatMeal(dayPlan.eveningSnack),
      dinner: formatMeal(dayPlan.dinner),
      totalMacros: {
        calories: dailyMacros.totalCalories + " kcal",
        protein: dailyMacros.totalProtein + "g",
        carbs: dailyMacros.totalCarbs + "g",
        fat: dailyMacros.totalFat + "g",
      },
    };
  });

  return formattedPlan;
}

/**
 * Format individual meal for display
 */
function formatMeal(meal) {
  const formatted = {
    name: meal.name,
    description: meal.description,
  };

  // Add nutritional info if available
  if (meal.nutritional_info) {
    formatted.nutritionalInfo = {
      calories: meal.nutritional_info.calories,
      protein: meal.nutritional_info.protein_grams + "g",
      carbs: meal.nutritional_info.carbs_grams + "g",
      fat: meal.nutritional_info.fat_grams + "g",
    };
  }

  // Add modifications if available
  if (meal.modifications) {
    formatted.healthModifications = meal.modifications.description;
    formatted.portionAdvice = meal.modifications.portionChanges;
    formatted.healthNotes = meal.modifications.additionalNotes;
  }

  return formatted;
}

/* Example usage: */
const userInputs = {
  age: "20-59",
  gender: "female",
  goal: "weight_loss",
  activity: "moderate",
  dietType: "vegetarian",
  existingDisease: "diabetes",
};

function generateDietTable(finalPlan) {
  const weeklyPlan = finalPlan.weeklyPlan;
  let tableHTML = `
    <table class="diet-table">
      <tr class="diet-header">
       <th class="diet-cell diet-day-mobile">Day</th> <!-- Day column for mobile -->
        <th class="diet-cell">Breakfast</th>
        <th class="diet-cell">Lunch</th>
        <th class="diet-cell">Dinner</th>
        <th class="diet-cell">Macros (Kcal/P/C/F)</th>
      </tr>`;

  Object.keys(weeklyPlan).forEach((day) => {
    const dayPlan = weeklyPlan[day];
    const breakfastIngredientList = dayPlan.breakfast.ingredients
      .map((ingredient) => `${ingredient.name} (${ingredient.quantity})`)
      .join(", ");
    const lunchIngredientList = dayPlan.lunch.ingredients
      .map((ingredient) => `${ingredient.name} (${ingredient.quantity})`)
      .join(", ");
    const dinnerIngredientList = dayPlan.dinner.ingredients
      .map((ingredient) => `${ingredient.name} (${ingredient.quantity})`)
      .join(", ");

    tableHTML += `
        <tr class="diet-day-row">
          <td colspan="4" class="diet-day">${day}</td>
        </tr>
        <tr class="diet-day-row">
         <td class="diet-cell diet-day-mobile">${day}</td> <!-- Day column for mobile -->
          <td class="diet-cell flip-card">
            <div class="flip-card">
                <div class="flip-card-inner">
                    <div class="flip-card-front">${dayPlan.breakfast.name}</div>
                    <div class="flip-card-back">🍽️ ${breakfastIngredientList}</div>
                </div>
            </div>
          </td>
          <td class="diet-cell flip-card">
            <div class="flip-card">
                <div class="flip-card-inner">
                    <div class="flip-card-front">${dayPlan.lunch.name}</div>
                    <div class="flip-card-back">🍽️ ${lunchIngredientList}</div>
                </div>
            </div>
          </td>
          <td class="diet-cell flip-card">
            <div class="flip-card">
                <div class="flip-card-inner">
                    <div class="flip-card-front">${dayPlan.dinner.name}</div>
                    <div class="flip-card-back">🍽️ ${dinnerIngredientList}</div>
                </div>
            </div>
          </td>
          <td class="diet-cell">⚖️ ${dayPlan.totalMacros.calories} kcal /
                ${dayPlan.totalMacros.protein} P /
                ${dayPlan.totalMacros.carbs} C /
                ${dayPlan.totalMacros.fats} F</td>
        </tr>`;
  });

  tableHTML += `</table>`;

  document.getElementById("diet-plan").innerHTML = tableHTML;
  finalDietPlan = weeklyPlan;
}

function getUniqueIngredients() {
  const uniqueIngredients = new Set();

  Object.values(finalDietPlan).forEach((dayPlan) => {
    ["breakfast", "morningSnack", "lunch", "eveningSnack", "dinner"].forEach(
      (mealType) => {
        const meal = dayPlan[mealType];
        if (meal && meal.ingredients) {
          meal.ingredients.forEach((ingredient) => {
            const normalizedIngredient = ingredient.name
              .toLowerCase()
              .replace(/s$/, ""); // Remove plural 's'
            uniqueIngredients.add(normalizedIngredient);
          });
        }
      }
    );
  });

  return [...uniqueIngredients];
}
function filterProductsByIngredients(products) {
  const ingredientsList = getUniqueIngredients();

  return products.filter(({ node }) => {
    const productTitle = node.title.toLowerCase();
    return ingredientsList.some((ingredient) =>
      productTitle.includes(ingredient)
    );
  });
}

/*
 * Fetch all the recommended products
 */
//   Fetch products from Shopify
window.fetchProducts = async (
  userFilters,
  cursor = null,
  accumulatedProducts = []
) => {
  if (!window.storefrontAccessToken) {
    console.error("Shopify URL or token is missing");
    return;
  }
  const tags = Object.values(userFilters).filter((tag) => tag); // Extract non-empty values
  if (!tags.length) return ""; // Return empty if no tags available

  const queryTags = tags.map((tag) => `tag:${tag}`).join(" OR ");
  // query: "${queryTags}"
  const query = `
        query getProducts($first: Int, $after: String) {
            products(first: $first, after: $after) {
                edges {
                    node {
                        id
                        title
                        description
                        images(first: 1) {
                            edges {
                                node {
                                    originalSrc
                                    altText
                                }
                            }
                        }
                        variants(first: 1) {
                            edges {
                                node {
                                    id
                                    price {
                                        amount
                                        currencyCode
                                    }
                                }
                            }
                        }
                    }
                    cursor
                }
                pageInfo {
                    hasNextPage
                    endCursor
                }
            }
        }
    `;
  try {
    const response = await fetch(
      `${shopifyStoreUrl}/api/2025-01/graphql.json`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": window.storefrontAccessToken,
        },
        body: JSON.stringify({
          query,
          variables: {
            first: 100, // Fetch up to 100 products at a time
            after: cursor,
          },
        }),
      }
    );
    const result = await response.json();
    const newProducts = result.data.products.edges;
    accumulatedProducts = [...accumulatedProducts, ...newProducts];

    if (result.data.products.pageInfo.hasNextPage) {
      // Fetch next batch using endCursor
      return fetchProducts(
        userFilters,
        result.data.products.pageInfo.endCursor,
        accumulatedProducts
      );
    } else {
      // Store all fetched products globally
      window.allFetchedProducts = accumulatedProducts;

      const filteredProducts = accumulatedProducts;
      displayProducts(filteredProducts);
      window.totalProductsForDietQuiz = filteredProducts.length;
    }
  } catch (error) {
    console.error("Error fetching products:", error);
  }
};

//   Add to cart button functionality
const attachAddToCartHandlers = () => {
  document.querySelectorAll(".add-to-cart").forEach((button) => {
    button.addEventListener("click", function () {
      let fullVariantId = this.getAttribute("data-variant-id"); // Full ID
      let variantId = fullVariantId.split("/").pop(); // Extract numeric ID
      fetch(`/cart/add.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ quantity: 1, id: variantId }),
      })
        .then((response) => response.json())
        .then((data) => {
          alert("Product added to cart!");
          return fetch("/cart.js").then((res) => res.json());
        })
        .then((cartData) => {
          document.cookie = `cartCount=${cartData.item_count}; path=/;`;
        })
        .catch((error) => console.error("Error adding to cart:", error));
    });
  });
};

/* Function to ensure exactly 8 products are displayed.
 * If filtered products are fewer than 8, it fills the remaining slots with random ones.
 */
function getExactEightProducts(filteredProducts) {
  let finalProducts = [...filteredProducts];
  let allProducts = window.allFetchedProducts;
  // If fewer than 8 products match, fill with random products from allProducts
  while (finalProducts.length < 8) {
    const randomProduct =
      allProducts[Math.floor(Math.random() * allProducts.length)];
    if (!finalProducts.includes(randomProduct)) {
      finalProducts.push(randomProduct);
    }
  }

  // Return only the first 8 products
  return finalProducts.slice(0, 8);
}

/*
 * Display the fetched product
 */
const displayProducts = (products) => {
  const filteredProducts = filterProductsByIngredients(products);
  // Ensure exactly 8 products are displayed
  const finalProducts = getExactEightProducts(filteredProducts);

  const productList = document.getElementById("product-list");
  productList.innerHTML = "";

  finalProducts.forEach(({ node }) => {
    const productHTML = `
              <div class="product-card" data-variant-id="${node.variants.edges[0]?.node.id}">
                  <img src="${node.images.edges[0]?.node.originalSrc}" alt="${node.images.edges[0]?.node.altText}">
                  <h4>${node.title}</h4>
                  <p>${node.description}</p>
                  <p class="price">₹ ${node.variants.edges[0]?.node.price.amount}</p>
                  <button class="add-to-cart" data-variant-id="${node.variants.edges[0]?.node.id}">Add to Cart</button>
              </div>
          `;
    productList.innerHTML += productHTML;
  });
  attachAddToCartHandlers();
  observeProductSection();
};

window.sendCustomerDataToShopify = async (userFilters) => {
  let email = document.getElementById("email").value;
  fetch(
    "https://diet-quiz-shopify-proxy.info-debataenterprise.workers.dev/save-customer-info",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email,
        first_name: userFilters.firstName,
        last_name: userFilters.lastName,
        age: userFilters.age,
        gender: userFilters.gender,
        goal: userFilters.goal,
        activity_level: userFilters.activity,
        health_condition: userFilters.condition,
        diet_type: userFilters.diet,
      }),
    }
  )
    .then((response) => response.json())
    .then((data) => {
      const customerId = data.customerId || "8045196312813";
      localStorage.setItem("customerId", customerId);
      window.printDesign("save");
    })
    .catch((error) => console.error("Error:", error));
};

// Scroll-triggered animation
const observeProductSection = () => {
  const productSection = document.getElementById("product-list");
  const productCards = document.querySelectorAll(".product-card");

  let observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          productCards.forEach((card, index) => {
            setTimeout(() => {
              card.classList.add("visible");
            }, index * 300);
          });
        }
      });
    },
    { threshold: 0.2 }
  );

  observer.observe(productSection);
};
window.printDesign = (type) => {
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  const triggerDownload = (url) => {
    // Try Blob download for better compatibility
    fetch(url)
      .then((res) => res.blob())
      .then((blob) => {
        const blobUrl = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = blobUrl;
        a.download = "Diet-Element-Nutrition-Plan.pdf";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(blobUrl);
      })
      .catch((err) => {
        console.error("⚠️ Download failed. Opening in new tab...", err);
        window.open(url, "_blank");
      });
  };

  const savedUrl = sessionStorage.getItem("generated-dn");

  if (type === "download") {
    if (savedUrl && savedUrl !== "null") {
      triggerDownload(savedUrl);
    } else {
      alert("⚠️ PDF not ready. Please click Save first.");
    }
  } else if (type === "save") {
    const runPDF = () => {
      generatePDF().then((uploadedUrl) => {
        if (uploadedUrl) {
          sessionStorage.setItem("generated-dn", uploadedUrl);
          console.log("✅ PDF saved to sessionStorage.");
        }
      });
    };

    if (!window.jspdf) {
      const script = document.createElement("script");
      script.src =
        "https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js";
      script.onload = runPDF;
      document.body.appendChild(script);
    } else {
      runPDF();
    }
  }
};

// window.onload = (event) => {
//   setTimeout(generatePDF, 4000);
// };

// Replace Later for original
const generatePDF = () => {
  var { jsPDF } = window.jspdf;

  var doc = new jsPDF("p", "mm", "a4");

  const imageKeys = [
    "landingPageDietPlan",
    "nutrientRecommendationsDietPlan",
    "everydayFoodChoicesDietPlan",
    "mealPlanDietPlan",
    "habitsDietPlan",
  ];

  function loadImage(keyOrUrl, fallbackKey = "defaultFallback") {
    return new Promise((resolve, reject) => {
      const url = window.assetPaths?.[keyOrUrl] || keyOrUrl;
      const fallbackUrl = window.assetPaths?.[fallbackKey];

      const img = new Image();
      img.crossOrigin = "anonymous";

      img.onload = () => resolve(img);

      img.onerror = (e) => {
        console.error(`❌ Failed to load image: ${url}`, e);
        if (fallbackUrl && url !== fallbackUrl) {
          console.log(`🔁 Trying fallback image: ${fallbackUrl}`);
          const fallbackImg = new Image();
          fallbackImg.crossOrigin = "anonymous";
          fallbackImg.onload = () => resolve(fallbackImg);
          fallbackImg.onerror = (err) => {
            console.error(`❌ Fallback image also failed: ${fallbackUrl}`, err);
            reject(err);
          };
          fallbackImg.src = fallbackUrl;
        } else {
          reject(e);
        }
      };

      img.src = url;
    });
  }

  async function addImagesToPDF() {
    // Get the finalPlan from wherever it's stored in your application
    // This is crucial - make sure finalPlan is properly defined and accessible
    // const finalPlan = window.finalPlan || {};

    for (let i = 0; i < imageKeys.length; i++) {
      try {
        const img = await loadImage(imageKeys[i]);
        if (i > 0) doc.addPage();
        doc.addImage(img, "PNG", 0, 0, 210, 297);

        if (i === 0) {
          doc.setFont("Helvetica", "normal");
          doc.setFontSize(15);
          doc.setTextColor(255, 255, 255);
          doc.text(`FOR ${userName.toUpperCase()}`, 80, 175);
        }
        if (i === 3) {
          if (!finalPlan || Object.keys(finalPlan).length === 0) {
            console.error("finalPlan is missing or empty:", finalPlan);
          }

          const planToUse =
            finalPlan && Object.keys(finalPlan).length > 0
              ? finalPlan
              : {
                  Monday: {
                    breakfast: { name: "Test Breakfast" },
                    lunch: { name: "Test Lunch" },
                    dinner: { name: "Test Dinner" },
                  },
                };

          const weeklyPlanArray = Object.keys(planToUse).map((day) => ({
            ...planToUse[day],
            day,
          }));

          // Each value is in millimeters on the PDF (A4 size: 210×297mm)
          const cellPositions = {
            rows: {
              Monday: 70,
              Tuesday: 95,
              Wednesday: 128,
              Thursday: 155,
              Friday: 183,
              Saturday: 210,
              Sunday: 240,
            },
            columns: {
              breakfast: 82,
              lunch: 125,
              dinner: 168, // X position for dinner column
            },
          };

          doc.setFont("Helvetica", "normal");
          doc.setFontSize(11.5); // Larger font
          doc.setTextColor(46, 125, 50);
          doc.setTextColor("#2e7d32");

          // Add meals for each day
          weeklyPlanArray.forEach((dayPlan) => {
            const y = cellPositions.rows[dayPlan.day];
            if (!y) {
              return;
            }

            // Helper function for adding text to a cell
            const addMealText = (text, x, y) => {
              if (!text) return;

              // Calculate width for word wrapping (30mm cell width)
              const cellWidth = 40;
              const lines = doc.splitTextToSize(text, cellWidth);

              // Center the text in the cell
              lines.forEach((line, i) => {
                const textWidth = doc.getTextWidth(line);
                const centeredX = x - textWidth / 2;
                doc.text(line, centeredX, y + i * 5);
              });
            };

            // Add breakfast, lunch, and dinner
            if (dayPlan.breakfast) {
              addMealText(
                dayPlan.breakfast.name,
                cellPositions.columns.breakfast,
                y
              );
            }

            if (dayPlan.lunch) {
              addMealText(dayPlan.lunch.name, cellPositions.columns.lunch, y);
            }

            if (dayPlan.dinner) {
              addMealText(dayPlan.dinner.name, cellPositions.columns.dinner, y);
            }
          });
        }
      } catch (error) {
        console.error(`Error processing page ${i}:`, error);
      }
    }

    const pdfBlob = doc.output("blob");
    // doc.save("Diet-Element-Nutrition-Plan.pdf"); // Save the PDF
    return pdfBlob;
  }

  return addImagesToPDF()
    .then(async (pdfBlob) => {
      try {
        const pdfUrl = await uploadPDF(pdfBlob);
        sessionStorage.setItem("generated-dn", pdfUrl);
        return pdfUrl;
      } catch (error) {
        console.error("Error uploading PDF:", error);
        throw error;
      }
    })
    .catch((error) => {
      console.error("Error generating PDF:", error);
      throw error;
    });
};

// Upload PDF to Cloudflare Worker
async function uploadPDF(pdfBlob) {
  const formData = new FormData();
  formData.append("file", pdfBlob, "Diet-Element-Nutrition-Plan.pdf");
  formData.append("customerId", localStorage.getItem("customerId"));

  try {
    const response = await fetch(
      "https://diet-quiz-shopify-proxy.info-debataenterprise.workers.dev/upload",
      {
        method: "POST",
        body: formData,
        headers: {
          Accept: "application/json",
        },
      }
    );

    const result = await response.json();
    if (result.success) {
      return result.fileUrl;
    } else {
      console.error("Upload failed:", result.error);
      return null;
    }
  } catch (error) {
    console.error("Error uploading PDF:", error);
    return null;
  }
}

window.signupHandler = () => {
  window.location.href = "https://account.dietelement.in";
};
